import { DESKTOP_NATIVE_ENGLISH } from "./desktop-native"
import { WORKFLOW_ENGLISH } from "./datox-workflows"
import { RISK_ENGLISH } from "./datox-risk"
import { APPROVALS_ENGLISH } from "./datox-approvals"
import { AUTOMATION_ENGLISH } from "./datox-automations"
import { FACTSHEET_ENGLISH } from "./datox-factsheet"
import { FACTSHEET_EXPERIENCE_ENGLISH } from "./datox-redesign"
import { REPORT_STUDIO_ENGLISH } from "./datox-reports"
import { FILE_INTEGRATIONS_ENGLISH } from "./datox-file-integrations"
import { OVERVIEW_ENGLISH } from "./datox-overview"
import { ACTIVITY_ENGLISH } from "./datox-activity"
import { V2_ENGLISH } from "./datox-v2"

export const dict = {
  ...DESKTOP_NATIVE_ENGLISH,
  ...WORKFLOW_ENGLISH,
  ...RISK_ENGLISH,
  ...APPROVALS_ENGLISH,
  ...AUTOMATION_ENGLISH,
  ...FACTSHEET_ENGLISH,
  ...FACTSHEET_EXPERIENCE_ENGLISH,
  ...REPORT_STUDIO_ENGLISH,
  ...FILE_INTEGRATIONS_ENGLISH,
  ...OVERVIEW_ENGLISH,
  ...ACTIVITY_ENGLISH,
  ...V2_ENGLISH,
  "datox.workflow.processing.loading": "Checking activity…",
  "datox.workflow.tab.saved": "Saved results available",
  "datox.workflow.tab.working": "Updating this step…",
  "datox.workflow.tab.approved": "Reviewers approved",
  "datox.workflow.processing.processing": "Processing…",
  "datox.workflow.processing.preparing": "Preparing workflow…",
  "datox.workflow.processing.reviewing": "Reviewing source files…",
  "datox.workflow.processing.extracting": "Extracting data…",
  "datox.workflow.processing.analysing": "Analyzing data…",
  "datox.workflow.processing.savingExtraction": "Saving extracted data…",
  "datox.workflow.processing.savingOutputs": "Saving calculated outputs…",
  "datox.workflow.processing.generatingReport": "Generating reports…",
  "datox.workflow.processing.savingReport": "Saving reports…",
  "datox.workflow.processing.buildingDashboard": "Building dashboards…",
  "datox.workflow.processing.savingDashboard": "Saving dashboards…",
  "datox.workflow.processing.validating": "Checking results…",
  "datox.workflow.processing.preparingOutputs": "Preparing outputs…",
  "datox.workflow.processing.coordinating": "Coordinating agents…",
  "datox.workflow.processing.thinking": "Thinking…",
  "datox.workflow.processing.responding": "Preparing response…",
  "datox.workflow.processing.retrying": "Retrying…",
  "datox.workflow.processing.waiting": "Waiting for your input",
  "datox.workflow.processing.waitingForFiles": "Waiting for files",
  "datox.workflow.processing.failed": "Processing stopped — needs attention",
  "datox.workflow.processing.interrupted": "Processing interrupted — saved results retained",
  "datox.workflow.processing.cancelling": "Cancelling processing…",
  "datox.workflow.processing.cancelled": "Processing cancelled",
  "datox.workflow.processing.idle": "No active processing",
  "datox.workflow.processing.unavailable": "Live status unavailable",
  "datox.reportTemplates.title": "Report Templates",
  "datox.revisions.label": "Revision",
  "datox.revisions.latest": "Latest completed",
  "datox.revisions.refresh": "Refresh",
  "datox.revisions.retrySave": "Retry saving",
  "datox.revisions.option": "Revision {{number}} · {{date}} UTC",
  "datox.revisions.incomplete": "Revision {{number}} · Incomplete · {{date}} UTC",
  "datox.revisions.error": "Could not load revision history.",
  "datox.revisions.readOnly": "Historical revision · Read only. Shared links show the latest completed revision.",
  "datox.revisions.loading": "Loading revision…",
  "datox.workflow.run.title": "Run",
  "datox.workflow.run.templates": "Templates",
  "datox.workflow.run.automation": "Automation",
  "datox.workflow.run.rerun": "Rerun",
  "datox.workflow.run.rerunFirst": "Run this workflow once to enable rerunning it.",
  "datox.workflow.run.rerunDescription": "Repeat the saved workflow in this period using current files and update reports and dashboards.",
  "datox.workflow.run.rerunStarted": "Rerun started",
  "datox.workflow.runs.title": "Run history",
  "datox.workflow.runs.description": "Review this workflow’s runs, progress and separate agent chats.",
  "datox.workflow.runs.navigation": "Workflow run navigation",
  "datox.workflow.runs.back": "Back to workflow",
  "datox.workflow.runs.empty": "No replay runs yet. Run this workflow once, then choose Run → Rerun to repeat it in this period.",
  "datox.workflow.runs.error": "The workflow run operation failed. Review the details and try again.",
  "datox.workflow.runs.loadError": "Could not load workflow runs. Refresh to try again.",
  "datox.workflow.runs.notFound": "This run is not available in this workflow. Return to run history to choose another run.",
  "datox.workflow.runs.next.files": "Open this workflow and add its files. Resume this run when the files are ready.",
  "datox.workflow.runs.next.running": "Read the latest agent response below or open this run’s chat. New results are saved in the same workflow.",
  "datox.workflow.runs.next.completed": "Open this workflow to review the updated data, reports and dashboards. Earlier revisions are preserved.",
  "datox.workflow.runs.next.cancelled": "Any outputs already saved remain in this workflow. To try again, open it and choose Run → Rerun.",
  "datox.workflow.runs.next.attention": "Review the response below. Resume retries this run with its original inputs. To use updated files, return to this workflow and choose Run → Rerun.",
  "datox.workflow.runs.next.unknown": "Refresh this page or open this workflow to check its results.",
  "datox.reportTemplates.description": "Choose a template to generate reports from this workflow's files.",
  "datox.reportTemplates.updateHint": "Running this template again saves new revisions of the existing reports and dashboards for each portfolio in this period.",
  "datox.reportTemplates.factsheetDescription": "Portfolio overview, performance and holdings for each client or portfolio.",
  "datox.reportTemplates.editableDashboard": "Editable dashboard",
  "datox.reportTemplates.sourceFiles": "Source files in this workflow",
  "datox.reportTemplates.chatHint": "Follow progress in the agent chat.",
  "datox.reportTemplates.factsheetPrompt": "Generate a factsheet report and a separate editable dashboard for each client/portfolio using only the selected source files in the current workflow period.",
  "datox.reportTemplates.generate": "Generate",
  "datox.reportTemplates.opening": "Opening chat…",
  "datox.reportTemplates.uploadFirst": "Upload files to this workflow before generating a report.",
  "datox.reportTemplates.error": "Could not start generation in the agent chat. Please try again.",
  "datox.reportTemplates.sourceFilesChanged": "The source files have changed or are no longer available. Close and reopen Templates to review the current workflow files.",
  "command.category.suggested": "Suggested",
  "command.category.view": "View",
  "command.category.project": "Project",
  "command.category.provider": "Provider",
  "command.category.server": "Server",
  "command.category.session": "Session",
  "command.category.theme": "Theme",
  "command.category.language": "Language",
  "command.category.file": "File",
  "command.category.context": "Context",
  "command.category.terminal": "Terminal",
  "command.category.model": "Model",
  "command.category.mcp": "MCP",
  "command.category.agent": "Agent",
  "command.category.permissions": "Permissions",
  "command.category.workspace": "Workspace",
  "command.category.settings": "Settings",
  "command.logs.export": "Export logs",

  "theme.scheme.system": "System",
  "theme.scheme.light": "Light",
  "theme.scheme.dark": "Dark",

  "command.sidebar.toggle": "Toggle sidebar",
  "command.project.open": "Open project",
  "command.project.previous": "Previous project",
  "command.project.next": "Next project",
  "command.project.index": "Switch to project {{index}}",
  "command.provider.connect": "Connect provider",
  "command.server.switch": "Switch server",
  "command.settings.open": "Open settings",
  "command.session.previous": "Previous session",
  "command.session.next": "Next session",
  "command.session.previous.unseen": "Previous unread session",
  "command.session.next.unseen": "Next unread session",
  "command.session.archive": "Archive session",

  "command.palette": "Command palette",

  "command.theme.cycle": "Cycle theme",
  "command.theme.set": "Use theme: {{theme}}",
  "command.theme.scheme.cycle": "Cycle color scheme",
  "command.theme.scheme.set": "Use color scheme: {{scheme}}",

  "command.language.cycle": "Cycle language",
  "command.language.set": "Use language: {{language}}",

  "command.session.new": "New session",
  "command.file.open": "Open file",
  "command.tab.close": "Close tab",
  "command.tab.reopenClosed": "Reopen closed tab",
  "command.context.addSelection": "Add selection to context",
  "command.context.addSelection.description": "Add selected lines from the current file",
  "command.input.focus": "Focus input",
  "command.terminal.toggle": "Toggle terminal",
  "command.fileTree.toggle": "Toggle file tree",
  "command.review.toggle": "Toggle review",
  "command.terminal.new": "New terminal",
  "command.terminal.new.description": "Create a new terminal tab",
  "command.steps.toggle": "Toggle steps",
  "command.steps.toggle.description": "Show or hide steps for the current message",
  "command.message.previous": "Previous message",
  "command.message.previous.description": "Go to the previous user message",
  "command.message.next": "Next message",
  "command.message.next.description": "Go to the next user message",
  "command.model.choose": "Choose model",
  "command.model.choose.description": "Select a different model",
  "command.mcp.toggle": "Toggle MCPs",
  "command.mcp.toggle.description": "Toggle MCPs",
  "command.agent.cycle": "Cycle agent",
  "command.agent.cycle.description": "Switch to the next agent",
  "command.agent.cycle.reverse": "Cycle agent backwards",
  "command.agent.cycle.reverse.description": "Switch to the previous agent",
  "command.model.variant.cycle": "Cycle thinking effort",
  "command.model.variant.cycle.description": "Switch to the next effort level",
  "command.prompt.mode.shell": "Shell",
  "command.prompt.mode.normal": "Prompt",
  "command.permissions.autoaccept.enable": "Auto-accept permissions",
  "command.permissions.autoaccept.disable": "Stop auto-accepting permissions",
  "command.workspace.toggle": "Toggle workspaces",
  "command.workspace.toggle.description": "Enable or disable multiple workspaces in the sidebar",
  "command.session.undo": "Undo",
  "command.session.undo.description": "Undo the last message",
  "command.session.redo": "Redo",
  "command.session.redo.description": "Redo the last undone message",
  "command.session.compact": "Compact session",
  "command.session.compact.description": "Summarize the session to reduce context size",
  "command.session.fork": "Fork from message",
  "command.session.fork.description": "Create a new session from a previous message",
  "command.session.share": "Share session",
  "command.session.share.description": "Share this session and copy the URL to clipboard",
  "command.session.unshare": "Unshare session",
  "command.session.unshare.description": "Stop sharing this session",
  "command.session.export": "Export session",
  "command.session.export.description": "Export the full session transcript as JSON",

  "palette.search.placeholder": "Search files, commands, and sessions",
  "palette.search.placeholder.home": "Search commands and sessions",
  "palette.empty": "No results found",
  "palette.group.commands": "Commands",
  "palette.group.files": "Files",

  "dialog.provider.search.placeholder": "Search providers",
  "dialog.provider.empty": "No providers found",
  "dialog.provider.group.popular": "Popular",
  "dialog.provider.group.other": "Other",
  "dialog.provider.custom.label": "Custom OpenAI-compatible provider",
  "dialog.provider.tag.recommended": "Recommended",
  "dialog.provider.opencode.note": "Curated models including Claude, GPT, Gemini and more",
  "dialog.provider.opencode.tagline": "Reliable optimized models",
  "dialog.provider.opencodeGo.tagline": "Low cost subscription for everyone",
  "dialog.provider.anthropic.note": "Direct access to Claude models, including Pro and Max",
  "dialog.provider.copilot.note": "AI models for coding assistance via GitHub Copilot",
  "dialog.provider.openai.note": "GPT models for fast, capable general AI tasks",
  "dialog.provider.google.note": "Gemini models for fast, structured responses",
  "dialog.provider.openrouter.note": "Access all supported models from one provider",
  "dialog.provider.vercel.note": "Unified access to AI models with smart routing",

  "dialog.model.select.title": "Select model",
  "dialog.model.search.placeholder": "Search models",
  "dialog.model.empty": "No model results",
  "dialog.model.manage": "Manage models",
  "dialog.model.manage.description": "Customize which models appear in the model selector.",
  "dialog.model.manage.provider.toggle": "Toggle all {{provider}} models",

  "dialog.model.unpaid.freeModels.title": "Free models provided by OpenCode",
  "dialog.model.unpaid.addMore.title": "Add more models from popular providers",
  "dialog.model.unpaid.viewMoreProviders": "See 70+ more providers",

  "dialog.provider.viewAll": "Show more providers",

  "provider.connect.title": "Connect {{provider}}",
  "provider.connect.title.anthropicProMax": "Login with Claude Pro/Max",
  "provider.connect.selectMethod": "Select login method for {{provider}}.",
  "provider.connect.method.apiKey": "API key",
  "provider.connect.method.browser": "Browser",
  "provider.connect.method.headless": "Headless",
  "provider.connect.status.inProgress": "Authorization in progress...",
  "provider.connect.status.waiting": "Waiting for authorization...",
  "provider.connect.status.failed": "Authorization failed: {{error}}",
  "provider.connect.apiKey.description":
    "Enter your {{provider}} API key to connect your account and use {{provider}} models in OpenCode.",
  "provider.connect.apiKey.label": "{{provider}} API key",
  "provider.connect.apiKey.placeholder": "API key",
  "provider.connect.apiKey.required": "API key is required",
  "provider.connect.opencodeZen.line1":
    "OpenCode Zen gives you access to a curated set of reliable optimized models for coding agents.",
  "provider.connect.opencodeZen.line2":
    "With a single API key you'll get access to models such as Claude, GPT, Gemini, GLM and more.",
  "provider.connect.opencodeZen.visit.prefix": "Visit ",
  "provider.connect.opencodeZen.visit.link": "opencode.ai/zen",
  "provider.connect.opencodeZen.visit.suffix": " to collect your API key.",
  "provider.connect.oauth.code.visit.prefix": "Visit ",
  "provider.connect.oauth.code.visit.link": "this link",
  "provider.connect.oauth.code.visit.suffix":
    " to collect your authorization code to connect your account and use {{provider}} models in OpenCode.",
  "provider.connect.oauth.code.label": "{{method}} authorization code",
  "provider.connect.oauth.code.placeholder": "Authorization code",
  "provider.connect.oauth.code.required": "Authorization code is required",
  "provider.connect.oauth.code.invalid": "Invalid authorization code",
  "provider.connect.oauth.auto.visit.prefix": "Visit ",
  "provider.connect.oauth.auto.visit.link": "this link",
  "provider.connect.oauth.auto.visit.suffix":
    " and enter the code below to connect your account and use {{provider}} models in OpenCode.",
  "provider.connect.oauth.auto.confirmationCode": "Confirmation code",
  "provider.connect.toast.connected.title": "{{provider}} connected",
  "provider.connect.toast.connected.description": "{{provider}} models are now available to use.",

  "provider.custom.title": "Custom provider",
  "provider.custom.unavailable": "Custom providers are unavailable on this server",
  "provider.custom.description.prefix": "Configure an OpenAI-compatible provider. See the ",
  "provider.custom.description.link": "provider config docs",
  "provider.custom.description.suffix": ".",
  "provider.custom.field.providerID.label": "Provider ID",
  "provider.custom.field.providerID.placeholder": "myprovider",
  "provider.custom.field.providerID.description": "Lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.field.name.label": "Display name",
  "provider.custom.field.name.placeholder": "My AI Provider",
  "provider.custom.field.baseURL.label": "Base URL",
  "provider.custom.field.baseURL.placeholder": "https://api.myprovider.com/v1",
  "provider.custom.field.apiKey.label": "API key",
  "provider.custom.field.apiKey.placeholder": "API key",
  "provider.custom.field.apiKey.description": "Optional. Leave empty if you manage auth via headers.",
  "provider.custom.models.label": "Models",
  "provider.custom.models.id.label": "ID",
  "provider.custom.models.id.placeholder": "model-id",
  "provider.custom.models.name.label": "Name",
  "provider.custom.models.name.placeholder": "Display Name",
  "provider.custom.models.remove": "Remove model",
  "provider.custom.models.add": "Add model",
  "provider.custom.headers.label": "Headers (optional)",
  "provider.custom.headers.key.label": "Header",
  "provider.custom.headers.key.placeholder": "Header-Name",
  "provider.custom.headers.value.label": "Value",
  "provider.custom.headers.value.placeholder": "value",
  "provider.custom.headers.remove": "Remove header",
  "provider.custom.headers.add": "Add header",
  "provider.custom.error.providerID.required": "Provider ID is required",
  "provider.custom.error.providerID.format": "Use lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.error.providerID.exists": "That provider ID already exists",
  "provider.custom.error.name.required": "Display name is required",
  "provider.custom.error.baseURL.required": "Base URL is required",
  "provider.custom.error.baseURL.format": "Must start with http:// or https://",
  "provider.custom.error.required": "Required",
  "provider.custom.error.duplicate": "Duplicate",

  "provider.disconnect.toast.disconnected.title": "{{provider}} disconnected",
  "provider.disconnect.toast.disconnected.description": "{{provider}} models are no longer available.",

  "model.tag.free": "Free",
  "model.tag.latest": "Latest",
  "model.provider.anthropic": "Anthropic",
  "model.provider.openai": "OpenAI",
  "model.provider.google": "Google",
  "model.provider.xai": "xAI",
  "model.provider.meta": "Meta",
  "model.input.text": "text",
  "model.input.image": "image",
  "model.input.audio": "audio",
  "model.input.video": "video",
  "model.input.pdf": "pdf",
  "model.tooltip.allows": "Allows: {{inputs}}",
  "model.tooltip.context.label": "Context",
  "model.tooltip.inputs": "Inputs",
  "model.tooltip.model": "Model",
  "model.tooltip.provider": "Provider",
  "model.tooltip.reasoning": "Reasoning",
  "model.tooltip.reasoning.allowed": "Allows reasoning",
  "model.tooltip.reasoning.none": "No reasoning",
  "model.tooltip.context": "Context limit {{limit}}",

  "common.search.placeholder": "Search",
  "common.goBack": "Navigate back",
  "common.goForward": "Navigate forward",
  "common.loading": "Loading",
  "common.loading.ellipsis": "...",
  "common.cancel": "Cancel",
  "common.clear": "Clear",
  "common.open": "Open",
  "common.connect": "Connect",
  "common.disconnect": "Disconnect",
  "common.continue": "Continue",
  "common.submit": "Submit",
  "common.save": "Save",
  "common.saving": "Saving...",
  "common.default": "Default",
  "common.attachment": "attachment",

  "prompt.placeholder.shell": "Enter shell command... {{example}}",
  "prompt.placeholder.normal": 'Ask anything... "{{example}}"',
  "prompt.placeholder.simple": "Ask anything...",
  "prompt.placeholder.summarizeComments": "Summarize comments…",
  "prompt.placeholder.summarizeComment": "Summarize comment…",
  "prompt.mode.shell": "Shell",
  "prompt.mode.normal": "Prompt",
  "prompt.mode.shell.exit": "esc to exit",
  "session.child.promptDisabled": "Subagent sessions cannot be prompted.",
  "session.child.backToParent": "Back to main session.",

  "prompt.example.1": "Fix a TODO in the codebase",
  "prompt.example.2": "What is the tech stack of this project?",
  "prompt.example.3": "Fix broken tests",
  "prompt.example.4": "Explain how authentication works",
  "prompt.example.5": "Find and fix security vulnerabilities",
  "prompt.example.6": "Add unit tests for the user service",
  "prompt.example.7": "Refactor this function to be more readable",
  "prompt.example.8": "What does this error mean?",
  "prompt.example.9": "Help me debug this issue",
  "prompt.example.10": "Generate API documentation",
  "prompt.example.11": "Optimize database queries",
  "prompt.example.12": "Add input validation",
  "prompt.example.13": "Create a new component for...",
  "prompt.example.14": "How do I deploy this project?",
  "prompt.example.15": "Review my code for best practices",
  "prompt.example.16": "Add error handling to this function",
  "prompt.example.17": "Explain this regex pattern",
  "prompt.example.18": "Convert this to TypeScript",
  "prompt.example.19": "Add logging throughout the codebase",
  "prompt.example.20": "What dependencies are outdated?",
  "prompt.example.21": "Help me write a migration script",
  "prompt.example.22": "Implement caching for this endpoint",
  "prompt.example.23": "Add pagination to this list",
  "prompt.example.24": "Create a CLI command for...",
  "prompt.example.25": "How do environment variables work here?",

  "prompt.popover.emptyResults": "No matching results",
  "prompt.popover.emptyCommands": "No matching commands",
  "prompt.dropzone.label": "Drop images, PDFs, or text files here",
  "prompt.dropzone.file.label": "Drop to @mention file",
  "prompt.slash.badge.custom": "custom",
  "prompt.slash.badge.skill": "skill",
  "prompt.slash.badge.mcp": "mcp",
  "prompt.context.active": "active",
  "prompt.context.includeActiveFile": "Include active file",
  "prompt.context.removeActiveFile": "Remove active file from context",
  "prompt.context.removeFile": "Remove file from context",
  "prompt.action.attachFile": "Add files",
  "prompt.menu.addImagesAndFiles": "Add files and more",
  "prompt.menu.imagesAndFiles": "Images and files",
  "prompt.menu.commands": "Commands",
  "prompt.menu.context": "Context",
  "prompt.menu.shellCommand": "Shell command",
  "prompt.attachment.remove": "Remove attachment",
  "prompt.action.send": "Send",
  "prompt.action.stop": "Stop",

  "prompt.toast.pasteUnsupported.title": "Unsupported attachment",
  "prompt.toast.pasteUnsupported.description": "Only images, PDFs, or text files can be attached here.",
  "prompt.toast.attachmentDuplicate.title": "This file has already been uploaded",
  "prompt.toast.modelAgentRequired.title": "Select an agent and model",
  "prompt.toast.modelAgentRequired.description": "Choose an agent and model before sending a prompt.",
  "prompt.toast.worktreeCreateFailed.title": "Failed to create worktree",
  "prompt.toast.sessionCreateFailed.title": "Failed to create session",
  "prompt.toast.shellSendFailed.title": "Failed to send shell command",
  "prompt.toast.commandSendFailed.title": "Failed to send command",
  "prompt.toast.promptSendFailed.title": "Failed to send prompt",
  "prompt.toast.promptSendFailed.description": "Unable to retrieve session",

  "dialog.mcp.title": "MCPs",
  "dialog.mcp.description": "{{enabled}} of {{total}} enabled",
  "dialog.mcp.empty": "No MCPs configured",

  "dialog.lsp.empty": "LSPs auto-detected from file types",
  "dialog.plugins.empty": "Plugins configured in opencode.json",

  "mcp.status.connected": "connected",
  "mcp.status.failed": "failed",
  "mcp.status.needs_auth": "needs auth",
  "mcp.status.disabled": "disabled",
  "mcp.auth.clickToAuthenticate": "Click to authenticate",

  "dialog.fork.empty": "No messages to fork from",

  "dialog.directory.search.placeholder": "Search folders",
  "dialog.directory.empty": "No folders found",
  "dialog.directory.action.selectFile": "Select file",
  "dialog.directory.action.selectFolder": "Select folder",
  "dialog.directory.root": "Root",
  "dialog.directory.parent": "Parent",
  "dialog.directory.readError": "Unable to read this folder",

  "app.server.unreachable": "Could not reach {{server}}",
  "app.server.retrying": "Retrying automatically...",
  "app.server.otherServers": "Other servers",

  "dialog.server.title": "Servers",
  "dialog.server.description": "Switch which OpenCode server this app connects to.",
  "dialog.server.search.placeholder": "Search servers",
  "dialog.server.empty": "No servers yet",
  "dialog.server.add.title": "Add server",
  "dialog.server.add.url": "Server address",
  "dialog.server.add.placeholder": "http://localhost:4096",
  "dialog.server.add.error": "Could not connect to server",
  "dialog.server.add.checking": "Checking...",
  "dialog.server.add.button": "Add server",
  "dialog.server.add.name": "Server name (optional)",
  "dialog.server.add.namePlaceholder": "Localhost",
  "dialog.server.add.username": "Username (optional)",
  "dialog.server.add.usernamePlaceholder": "username",
  "dialog.server.add.password": "Password (optional)",
  "dialog.server.add.passwordPlaceholder": "password",
  "dialog.server.edit.title": "Edit server",
  "dialog.server.default.title": "Default server",
  "dialog.server.default.description":
    "Connect to this server on app launch instead of starting a local server. Requires restart.",
  "dialog.server.default.none": "No server selected",
  "dialog.server.default.set": "Set current server as default",
  "dialog.server.default.clear": "Clear",
  "dialog.server.action.remove": "Remove server",

  "dialog.server.menu.edit": "Edit",
  "dialog.server.menu.default": "Set as default",
  "dialog.server.menu.defaultRemove": "Remove default",
  "dialog.server.menu.delete": "Delete",
  "dialog.server.current": "Current Server",
  "dialog.server.status.default": "Default",
  "wsl.server.add": "Add WSL server",
  "wsl.server.addShort": "Add WSL",
  "wsl.server.label": "WSL",
  "wsl.server.menu.label": "WSL server",
  "wsl.server.retryStart": "Retry start",
  "wsl.server.updating": "Updating...",
  "wsl.onboarding.step.distro": "Choose distro",
  "wsl.onboarding.step.opencode": "OpenCode",
  "wsl.onboarding.checkingRuntime": "Checking WSL...",
  "wsl.onboarding.restartRequired": "Windows needs a restart to finish installing WSL.",
  "wsl.onboarding.ready": "WSL is ready.",
  "wsl.onboarding.required": "WSL is required to continue.",
  "wsl.onboarding.checkingDistros": "Checking distros...",
  "wsl.onboarding.installingDistro": "Installing {{distro}}...",
  "wsl.onboarding.checkingDistro": "Checking {{distro}}...",
  "wsl.onboarding.listingDistros": "Listing distros...",
  "wsl.onboarding.distroReady": "{{distro}} is ready.",
  "wsl.onboarding.distroNotInstalled": "{{distro}} is not installed yet.",
  "wsl.onboarding.openDistroOnce": "Open {{distro}} once to finish setup.",
  "wsl.onboarding.finishingDistro": "Finishing setup for {{distro}}.",
  "wsl.onboarding.pickDistro": "Pick a distro or install one below.",
  "wsl.onboarding.checkingOpencode": "Checking OpenCode...",
  "wsl.onboarding.checkingOpencodeIn": "Checking OpenCode in {{distro}}...",
  "wsl.onboarding.updatingOpencode": "Updating OpenCode...",
  "wsl.onboarding.updatingOpencodeIn": "Updating OpenCode in {{distro}}...",
  "wsl.onboarding.updateOpencodeIn": "Update OpenCode in {{distro}}.",
  "wsl.onboarding.updateOpencode": "Update OpenCode",
  "wsl.onboarding.opencodeReadyIn": "OpenCode is ready in {{distro}}.",
  "wsl.onboarding.opencodeReady": "OpenCode is ready.",
  "wsl.onboarding.installOpencodeIn": "Install OpenCode in {{distro}}.",
  "wsl.onboarding.installOpencode": "Install OpenCode",
  "wsl.onboarding.chooseDistroFirst": "Choose a distro first.",
  "wsl.onboarding.loadFailed": "Failed to load WSL state.",
  "wsl.onboarding.loading": "Loading...",
  "wsl.onboarding.installedDistros": "Installed distros",
  "wsl.onboarding.checkAgain": "Check again",
  "wsl.onboarding.distroStatus.ready": "Ready",
  "wsl.onboarding.distroStatus.checking": "Checking...",
  "wsl.onboarding.distroStatus.opencodeMissing": "OpenCode not installed",
  "wsl.onboarding.distroStatus.missingTools": "Missing bash, curl",
  "wsl.onboarding.distroStatus.unsupported": "Unsupported · Use WSL 2",
  "wsl.onboarding.needAnotherDistro": "Need another distro?",
  "wsl.onboarding.needAnotherDistroHint": "Install a Linux distribution from the WSL catalog",
  "wsl.onboarding.wslNotInstalled.title": "WSL not installed",
  "wsl.onboarding.wslNotInstalled.description":
    "WSL (Windows Subsystem for Linux) is required before OpenCode can add a WSL server",
  "wsl.onboarding.wslUnavailable.title": "WSL unavailable",
  "wsl.onboarding.wslUnavailable.description": "OpenCode could not verify WSL on this machine.",
  "wsl.onboarding.installWsl": "Install WSL",
  "wsl.onboarding.windowsRestartRequired": "Restart Windows to finish installing WSL, then reopen OpenCode.",
  "wsl.onboarding.next": "Next",
  "wsl.onboarding.refresh": "Refresh",
  "wsl.onboarding.allDistrosAdded": "All installed distros are already added.",
  "wsl.onboarding.noDistros": "No distros detected yet.",
  "wsl.onboarding.install": "Install",
  "wsl.onboarding.installing": "Installing...",
  "wsl.onboarding.installDistro": "Install distro",
  "wsl.onboarding.searchDistros": "Search distros",
  "wsl.onboarding.wsl2Required": "WSL 2 is required.",
  "wsl.onboarding.toolsRequired": "This distro needs bash and curl.",
  "wsl.onboarding.openTerminal": "Open terminal",
  "wsl.onboarding.path": "Path: {{path}}",
  "wsl.onboarding.notFound": "not found",
  "wsl.onboarding.version": "Version: {{version}}",
  "wsl.onboarding.unknown": "unknown",
  "wsl.onboarding.desktopVersion": "desktop {{version}}",
  "wsl.onboarding.versionMismatch": "Installed version does not match the desktop app version.",
  "wsl.onboarding.adding": "Adding...",

  "help.tabs.toast.ariaLabel": "Introducing Tabs. Organize your work and active sessions with tabs",
  "help.tabs.toast.dismiss": "Dismiss Tabs information",
  "help.tabs.title": "Introducing Tabs",
  "help.tabs.description": "Organize your work and active sessions with tabs",
  "help.tabs.date": "July 14",
  "help.tabs.introduction": "OpenCode Desktop is now built around tabs.",
  "help.tabs.sessions":
    "Start a new session in a tab, or open an existing session from any of your projects. Open a new tab when you're starting something new, and close it when you're done.",
  "help.tabs.organize":
    "Keeping a few tabs open makes it easier to organize your active sessions. Rename tabs to something memorable if you plan to keep them around.",
  "help.tabs.home":
    "You'll find all your sessions and projects on the new Home screen. Selecting a session opens it in a tab.",
  "help.tabs.persistence": "When you reopen the app, your tabs are still open.",
  "help.tabs.worktrees":
    "The new design does not support Git Worktrees yet, it's coming soon. So if you'd prefer to continue using the previous layout, you can switch between layouts in Settings. Just keep in mind that the new layout will become permanent in a few weeks.",
  "server.row.noUsername": "no username",

  "dialog.project.edit.title": "Edit project",
  "dialog.project.edit.name": "Name",
  "dialog.project.edit.icon": "Icon",
  "dialog.project.edit.icon.alt": "Project icon",
  "dialog.project.edit.icon.hint": "Click or drag an image",
  "dialog.project.edit.icon.recommended": "Recommended: 128x128px",
  "dialog.project.edit.color": "Color",
  "dialog.project.edit.color.select": "Select {{color}} color",
  "dialog.project.edit.worktree.startup": "Workspace startup script",
  "dialog.project.edit.worktree.startup.description": "Runs after creating a new workspace (worktree).",
  "dialog.project.edit.worktree.startup.placeholder": "e.g. bun install",

  "dialog.releaseNotes.action.getStarted": "Get started",
  "dialog.releaseNotes.action.next": "Next",
  "dialog.releaseNotes.action.hideFuture": "Don't show these in the future",
  "dialog.releaseNotes.media.alt": "Release preview",
  "dialog.usageExceeded.dontShowAgain": "Don't show again",

  "context.breakdown.title": "Context Breakdown",
  "context.breakdown.note": 'Approximate breakdown of input tokens. "Other" includes tool definitions and overhead.',
  "context.breakdown.system": "System",
  "context.breakdown.user": "User",
  "context.breakdown.assistant": "Assistant",
  "context.breakdown.tool": "Tool Calls",
  "context.breakdown.other": "Other",

  "context.systemPrompt.title": "System Prompt",
  "context.rawMessages.title": "Raw messages",
  "context.export.session": "Export session",

  "context.stats.session": "Session",
  "context.stats.messages": "Messages",
  "context.stats.provider": "Provider",
  "context.stats.model": "Model",
  "context.stats.limit": "Context Limit",
  "context.stats.totalTokens": "Total Tokens",
  "context.stats.usage": "Usage",
  "context.stats.inputTokens": "Input Tokens",
  "context.stats.outputTokens": "Output Tokens",
  "context.stats.reasoningTokens": "Reasoning Tokens",
  "context.stats.cacheTokens": "Cache Tokens (read/write)",
  "context.stats.userMessages": "User Messages",
  "context.stats.assistantMessages": "Assistant Messages",
  "context.stats.totalCost": "Total Cost",
  "context.stats.sessionCreated": "Session Created",
  "context.stats.lastActivity": "Last Activity",

  "context.usage.tokens": "Tokens",
  "context.usage.usage": "Usage",
  "context.usage.cost": "Cost",
  "context.usage.clickToView": "Click to view context",
  "context.usage.view": "View context usage",

  "language.en": "English",
  "language.zh": "简体中文",
  "language.zht": "繁體中文",
  "language.ko": "한국어",
  "language.de": "Deutsch",
  "language.es": "Español",
  "language.fr": "Français",
  "language.da": "Dansk",
  "language.ja": "日本語",
  "language.pl": "Polski",
  "language.ru": "Русский",
  "language.ar": "العربية",
  "language.no": "Norsk",
  "language.br": "Português (Brasil)",
  "language.bs": "Bosanski",
  "language.uk": "Українська",
  "language.th": "ไทย",
  "language.tr": "Türkçe",

  "toast.language.title": "Language",
  "toast.language.description": "Switched to {{language}}",

  "toast.theme.title": "Theme switched",
  "toast.scheme.title": "Color scheme",

  "toast.workspace.enabled.title": "Workspaces enabled",
  "toast.workspace.enabled.description": "Multiple worktrees are now shown in the sidebar",
  "toast.workspace.disabled.title": "Workspaces disabled",
  "toast.workspace.disabled.description": "Only the main worktree is shown in the sidebar",

  "toast.permissions.autoaccept.on.title": "Auto-accepting permissions",
  "toast.permissions.autoaccept.on.description": "Permission requests will be automatically approved",
  "toast.permissions.autoaccept.off.title": "Stopped auto-accepting permissions",
  "toast.permissions.autoaccept.off.description": "Permission requests will require approval",

  "toast.model.none.title": "No model selected",
  "toast.model.none.description": "Connect a provider to summarize this session",

  "toast.file.loadFailed.title": "Failed to load file",
  "toast.file.listFailed.title": "Failed to list files",

  "toast.context.noLineSelection.title": "No line selection",
  "toast.context.noLineSelection.description": "Select a line range in a file tab first.",

  "toast.session.share.copyFailed.title": "Failed to copy URL to clipboard",
  "toast.session.share.success.title": "Session shared",
  "toast.session.share.success.description": "Share URL copied to clipboard!",
  "toast.session.share.failed.title": "Failed to share session",
  "toast.session.share.failed.description": "An error occurred while sharing the session",

  "toast.session.unshare.success.title": "Session unshared",
  "toast.session.unshare.success.description": "Session unshared successfully!",
  "toast.session.unshare.failed.title": "Failed to unshare session",
  "toast.session.unshare.failed.description": "An error occurred while unsharing the session",

  "toast.session.export.success.title": "Session exported",
  "toast.session.export.success.description": "Saved session to {{filename}}",
  "toast.session.export.failed.title": "Failed to export session",
  "toast.session.export.failed.description": "An error occurred while exporting the session",

  "toast.session.listFailed.title": "Failed to load sessions for {{project}}",
  "toast.project.reloadFailed.title": "Failed to reload {{project}}",

  "toast.update.title": "Update available",
  "toast.update.description": "A new version of OpenCode ({{version}}) is now available to install.",
  "toast.update.action.installRestart": "Install and restart",
  "toast.update.action.notYet": "Not yet",

  "error.page.title": "Something went wrong",
  "error.page.description": "An error occurred while loading the application.",
  "error.page.description.localServerStartup": "An error occurred while starting the local server.",
  "error.page.details.label": "Error Details",
  "error.page.action.restart": "Restart",
  "error.page.action.report": "Report Error",
  "error.page.action.reported": "Error Reported",
  "error.page.action.exportLogs": "Export Logs",
  "error.page.action.checking": "Checking...",
  "error.page.action.checkUpdates": "Check for updates",
  "error.page.action.updateTo": "Update to {{version}}",
  "error.page.circular": "[Circular]",
  "error.page.report.prefix": "Please report this error to the OpenCode team",
  "error.page.report.discord": "on Discord",
  "error.page.version": "Version: {{version}}",

  "error.dev.rootNotFound":
    "Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?",

  "error.serverSync.connectFailed": "Could not connect to server. Is there a server running at `{{url}}`?",
  "error.serverSDK.noServerAvailable": "No server available",
  "error.serverSDK.serverNotAvailable": "Server not available",
  "error.childStore.persistedCacheCreateFailed": "Failed to create persisted cache",
  "error.childStore.persistedProjectMetadataCreateFailed": "Failed to create persisted project metadata",
  "error.childStore.persistedProjectIconCreateFailed": "Failed to create persisted project icon",
  "error.childStore.storeCreateFailed": "Failed to create store",
  "directory.error.invalidUrl": "Invalid directory in URL.",

  "error.chain.unknown": "Unknown error",
  "error.server.invalidConfiguration": "Invalid configuration",
  "error.chain.causedBy": "Caused by:",
  "error.chain.apiError": "API error",
  "error.chain.status": "Status: {{status}}",
  "error.chain.retryable": "Retryable: {{retryable}}",
  "error.chain.responseBody": "Response body:\n{{body}}",
  "error.chain.didYouMean": "Did you mean: {{suggestions}}",
  "error.chain.modelNotFound": "Model not found: {{provider}}/{{model}}",
  "error.chain.checkConfig": "Check your config (opencode.json) provider/model names",
  "error.chain.mcpFailed": 'MCP server "{{name}}" failed. Note, OpenCode does not support MCP authentication yet.',
  "error.chain.providerAuthFailed": "Provider authentication failed ({{provider}}): {{message}}",
  "error.chain.providerInitFailed":
    'Failed to initialize provider "{{provider}}". Check credentials and configuration.',
  "error.chain.configJsonInvalid": "Config file at {{path}} is not valid JSON(C)",
  "error.chain.configJsonInvalidWithMessage": "Config file at {{path}} is not valid JSON(C): {{message}}",
  "error.chain.configDirectoryTypo":
    'Directory "{{dir}}" in {{path}} is not valid. Rename the directory to "{{suggestion}}" or remove it. This is a common typo.',
  "error.chain.configFrontmatterError": "Failed to parse frontmatter in {{path}}:\n{{message}}",
  "error.chain.configInvalid": "Config file at {{path}} is invalid",
  "error.chain.configInvalidWithMessage": "Config file at {{path}} is invalid: {{message}}",

  "notification.permission.title": "Permission required",
  "notification.permission.description": "{{sessionTitle}} in {{projectName}} needs permission",
  "notification.question.title": "Question",
  "notification.question.description": "{{sessionTitle}} in {{projectName}} has a question",
  "notification.action.goToSession": "Go to session",

  "notification.session.responseReady.title": "Response ready",
  "notification.session.error.title": "Session error",
  "notification.session.error.fallbackDescription": "An error occurred",

  "home.recentProjects": "Recent projects",
  "home.empty.title": "No recent projects",
  "home.empty.description": "Get started by opening a local project",
  "home.title": "Home",
  "home.projects": "Projects",
  "home.project.add": "Add project",
  "home.recentlyClosed": "Recently closed",
  "home.server.collapse": "Collapse server projects",
  "home.server.expand": "Expand server projects",
  "home.sessions.search.placeholder": "Search sessions",
  "home.sessions.search.placeholder.scoped": "Search sessions in {{scope}}",
  "home.sessions.search.sessions": "Sessions",
  "home.sessions.search.noResults": "No sessions found for {{query}}",
  "home.sessions.empty": "Nothing here yet",
  "home.sessions.empty.description": "Create a session to get started",
  "home.sessions.group.today": "Today",
  "home.sessions.group.yesterday": "Yesterday",
  "home.sessions.group.older": "Older",
  "home.providerTip": "Connect to 75+ providers to use other models, including Claude, GPT, Gemini, etc",

  "session.tab.session": "Session",
  "session.tab.review": "Review",
  "session.tab.context": "Context",
  "session.tab.unknown": "Unknown Session",
  "session.panel.reviewAndFiles": "Review and files",
  "session.error.notFound": "This session cannot be found",
  "session.error.notFound.description": "This tab points to a session that no longer exists on this server.",
  "session.error.notFound.closeTab": "Close Tab",
  "session.error.serverConnection": "Can't connect to this server",
  "session.review.filesChanged": "Files Changed {{count}}",
  "session.review.change.one": "Change",
  "session.review.change.other": "Changes",
  "session.review.loadingChanges": "Loading changes...",
  "session.review.empty": "No changes in this session yet",
  "session.review.noVcs": "No Git Version Control System detected, changes not displayed",
  "session.review.noVcs.createGit.title": "Create a Git repository",
  "session.review.noVcs.createGit.description": "Track, review, and undo changes in this project",
  "session.review.noVcs.createGit.actionLoading": "Creating Git repository...",
  "session.review.noVcs.createGit.action": "Create Git repository",
  "session.review.noSnapshot": "Snapshot tracking is disabled in config, so session changes are unavailable",
  "session.review.noChanges": "No changes",
  "session.review.noUncommittedChanges": "No uncommitted changes yet",
  "session.review.noBranchChanges": "No branch changes yet",

  "session.files.selectToOpen": "Select a file to open",
  "session.files.all": "All files",
  "session.files.empty": "No files",
  "session.files.binaryContent": "Binary file (content cannot be displayed)",

  "session.messages.renderEarlier": "Render earlier messages",
  "session.messages.loadingEarlier": "Loading earlier messages...",
  "session.messages.loadEarlier": "Load earlier messages",
  "session.messages.loading": "Loading messages...",
  "session.messages.jumpToLatest": "Jump to latest",

  "session.context.addToContext": "Add {{selection}} to context",
  "session.todo.title": "Todos",
  "session.todo.collapse": "Collapse",
  "session.todo.expand": "Expand",
  "session.todo.progress": "{{done}} of {{total}} todos completed",
  "session.question.progress": "{{current}} of {{total}} questions",
  "session.question.minimize": "Minimize question",
  "session.question.restore": "Restore question",
  "session.question.pending.one": "{{count}} pending question",
  "session.question.pending.other": "{{count}} pending questions",
  "session.followupDock.summary.one": "{{count}} queued message",
  "session.followupDock.summary.other": "{{count}} queued messages",
  "session.followupDock.sendNow": "Send now",
  "session.followupDock.edit": "Edit",
  "session.followupDock.collapse": "Collapse queued messages",
  "session.followupDock.expand": "Expand queued messages",
  "session.revertDock.summary.one": "{{count}} rolled back message",
  "session.revertDock.summary.other": "{{count}} rolled back messages",
  "session.revertDock.collapse": "Collapse rolled back messages",
  "session.revertDock.expand": "Expand rolled back messages",
  "session.revertDock.restore": "Restore message",

  "session.new.title": "Build anything",
  "session.new.project.new": "New project",
  "session.new.project.search": "Search projects",
  "session.new.project.add": "Add project",
  "session.new.worktree.main": "Main branch",
  "session.new.worktree.mainWithBranch": "Main branch ({{branch}})",
  "session.new.worktree.create": "Create new worktree",
  "session.new.workspace.runIn": "Run session in",
  "session.new.workspace.triggerLocal": "Local",
  "session.new.workspace.local": "Local repository",
  "session.new.workspace.existing": "Workspace…",
  "session.new.git.none": "No Git",
  "session.new.lastModified": "Last modified",

  "session.header.search.placeholder": "Search {{project}}",
  "session.header.searchFiles": "Search files",
  "session.header.openIn": "Open in",
  "session.header.open.action": "Open {{app}}",
  "session.header.open.ariaLabel": "Open in {{app}}",
  "session.header.open.menu": "Open options",
  "session.header.open.copyPath": "Copy path",
  "session.header.open.finder": "Finder",
  "session.header.open.fileExplorer": "File Explorer",
  "session.header.open.fileManager": "File Manager",
  "session.header.reveal.finder": "Reveal in Finder",
  "session.header.reveal.fileExplorer": "Reveal in File Explorer",
  "session.header.reveal.containingFolder": "Open containing folder",
  "session.header.open.app.vscode": "VS Code",
  "session.header.open.app.cursor": "Cursor",
  "session.header.open.app.zed": "Zed",
  "session.header.open.app.textmate": "TextMate",
  "session.header.open.app.antigravity": "Antigravity",
  "session.header.open.app.terminal": "Terminal",
  "session.header.open.app.iterm2": "iTerm2",
  "session.header.open.app.ghostty": "Ghostty",
  "session.header.open.app.warp": "Warp",
  "session.header.open.app.xcode": "Xcode",
  "session.header.open.app.androidStudio": "Android Studio",
  "session.header.open.app.powershell": "PowerShell",
  "session.header.open.app.sublimeText": "Sublime Text",

  "status.popover.trigger": "Status",
  "status.popover.ariaLabel": "Server configurations",
  "status.popover.tab.servers": "Servers",
  "status.popover.tab.mcp": "MCP",
  "status.popover.tab.lsp": "LSP",
  "status.popover.tab.plugins": "Plugins",
  "status.popover.action.manageServers": "Manage servers",

  "session.share.popover.title": "Publish on web",
  "session.share.popover.description.shared":
    "This session is public on the web. It is accessible to anyone with the link.",
  "session.share.popover.description.unshared":
    "Share session publicly on the web. It will be accessible to anyone with the link.",
  "session.share.action.share": "Share",
  "session.share.action.publish": "Publish",
  "session.share.action.publishing": "Publishing...",
  "session.share.action.unpublish": "Unpublish",
  "session.share.action.unpublishing": "Unpublishing...",
  "session.share.action.view": "View",
  "session.share.copy.copied": "Copied",
  "session.share.copy.copyLink": "Copy link",

  "lsp.tooltip.none": "No LSP servers",
  "lsp.label.connected": "{{count}} LSP",

  "prompt.loading": "Loading prompt...",
  "terminal.loading": "Loading terminal...",
  "terminal.title": "Terminal",
  "terminal.title.numbered": "Terminal {{number}}",
  "terminal.close": "Close terminal",
  "terminal.connectionLost.title": "Connection Lost",
  "terminal.connectionLost.abnormalClose": "WebSocket closed abnormally: {{code}}",
  "terminal.connectionLost.description":
    "The terminal connection was interrupted. This can happen when the server restarts.",
  "terminal.connectTicket.csrfError":
    "PTY connect ticket rejected by origin or CSRF checks. Check the server CORS config.",
  "terminal.connectTicket.statusError": "PTY connect ticket failed with {{status}}",

  "titlebar.update": "Update",
  "titlebar.updateVersion": "Update {{version}}",

  "common.closeTab": "Close tab",
  "common.dismiss": "Dismiss",
  "common.moreCountSuffix": " (+{{count}} more)",
  "common.requestFailed": "Request failed",
  "common.moreOptions": "More options",
  "common.learnMore": "Learn more",
  "common.rename": "Rename",
  "common.export": "Export",
  "common.reset": "Reset",
  "common.archive": "Archive",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.edit": "Edit",
  "common.loadMore": "Load more",
  "common.key.esc": "ESC",
  "common.key.ctrl": "Ctrl",
  "common.key.alt": "Alt",
  "common.key.shift": "Shift",
  "common.key.meta": "Meta",
  "common.key.space": "Space",
  "common.key.backspace": "Backspace",
  "common.key.enter": "Enter",
  "common.key.tab": "Tab",
  "common.key.delete": "Delete",
  "common.key.home": "Home",
  "common.key.end": "End",
  "common.key.pageUp": "Page Up",
  "common.key.pageDown": "Page Down",
  "common.key.insert": "Insert",
  "common.unknown": "unknown",

  "common.time.justNow": "Just now",
  "common.time.minutesAgo.short": "{{count}}m ago",
  "common.time.hoursAgo.short": "{{count}}h ago",
  "common.time.daysAgo.short": "{{count}}d ago",

  "sidebar.menu.toggle": "Toggle menu",
  "sidebar.nav.projectsAndSessions": "Projects and sessions",
  "sidebar.settings": "Settings",
  "sidebar.help": "Help",
  "sidebar.workspaces.enable": "Enable workspaces",
  "sidebar.workspaces.disable": "Disable workspaces",
  "sidebar.gettingStarted.title": "Getting started",
  "sidebar.gettingStarted.line1": "OpenCode includes free models so you can start immediately.",
  "sidebar.gettingStarted.line2": "Connect any provider to use models, inc. Claude, GPT, Gemini etc.",
  "sidebar.project.recentSessions": "Recent sessions",
  "sidebar.project.viewAllSessions": "View all sessions",
  "sidebar.project.clearNotifications": "Clear notifications",
  "sidebar.empty.title": "No projects open",
  "sidebar.empty.description": "Open a project to get started",

  "debugBar.ariaLabel": "Development performance diagnostics",
  "debugBar.na": "n/a",
  "debugBar.nav.label": "NAV",
  "debugBar.nav.tip":
    "Last completed route transition touching a session page, measured from router start until the first paint after it settles.",
  "debugBar.fps.label": "FPS",
  "debugBar.fps.tip": "Rolling frames per second over the last 5 seconds.",
  "debugBar.frame.label": "FRAME",
  "debugBar.frame.tip": "Worst frame time over the last 5 seconds.",
  "debugBar.jank.label": "JANK",
  "debugBar.jank.tip": "Frames over 32ms in the last 5 seconds.",
  "debugBar.long.label": "LONG",
  "debugBar.long.tip": "Blocked time and long-task count in the last 5 seconds. Max task: {{max}}.",
  "debugBar.delay.label": "DELAY",
  "debugBar.delay.tip": "Worst observed input delay in the last 5 seconds.",
  "debugBar.inp.label": "INP",
  "debugBar.inp.tip":
    "Approximate interaction duration over the last 5 seconds. This is INP-like, not the official Web Vitals INP.",
  "debugBar.cls.label": "CLS",
  "debugBar.cls.tip": "Cumulative layout shift for the current app lifetime.",
  "debugBar.mem.label": "MEM",
  "debugBar.mem.tipUnavailable": "Used JS heap vs heap limit. Chromium only.",
  "debugBar.mem.tip": "Used JS heap vs heap limit. {{used}} of {{limit}}.",
  "debugBar.focus.label": "FOCUS",
  "debugBar.focus.tip": "Force focus styles on all interactive elements",
  "debugBar.focus.on": "ON",
  "debugBar.focus.off": "OFF",
  "debugBar.direction.label": "DIR",
  "debugBar.direction.tip": "Force the full app layout direction without changing the selected language",
  "debugBar.direction.ltr": "LTR",
  "debugBar.direction.rtl": "RTL",

  "app.name.desktop": "OpenCode Desktop",

  "settings.section.desktop": "Desktop",
  "settings.section.server": "Server",
  "settings.tab.general": "General",
  "settings.tab.shortcuts": "Shortcuts",
  "settings.desktop.section.wsl": "WSL",
  "settings.desktop.wsl.title": "WSL integration",
  "settings.desktop.wsl.description": "Run the OpenCode server inside WSL on Windows.",

  "settings.general.section.appearance": "Appearance",
  "settings.general.section.advanced": "Advanced",
  "settings.general.section.notifications": "System notifications",
  "settings.general.section.updates": "Updates",
  "settings.general.section.sounds": "Sound effects",
  "settings.general.section.feed": "Feed",
  "settings.general.section.display": "Display",

  "settings.general.row.language.title": "Language",
  "settings.general.row.language.description": "Change the display language for OpenCode",
  "settings.general.row.shell.title": "Terminal shell",
  "settings.general.row.shell.description": "Shell used by the terminal and agent tools",
  "settings.general.row.shell.autoDefault": "Auto (Default)",
  "settings.general.row.shell.terminalOnly": "terminal only",
  "settings.general.row.appearance.title": "Appearance",
  "settings.general.row.appearance.description": "Customise how OpenCode looks on your device",
  "settings.general.row.colorScheme.title": "Color scheme",
  "settings.general.row.colorScheme.description": "Choose whether OpenCode follows the system, light, or dark theme",
  "settings.general.row.theme.title": "Theme",
  "settings.general.row.theme.description": "Customise how OpenCode is themed.",
  "settings.general.row.font.title": "Code Font",
  "settings.general.row.font.description": "Customise the font used in code blocks",
  "settings.general.row.terminalFont.title": "Terminal Font",
  "settings.general.row.terminalFont.description": "Customise the font used in the terminal",
  "settings.general.row.uiFont.title": "UI Font",
  "settings.general.row.uiFont.description": "Customise the font used throughout the interface",
  "settings.general.row.followup.title": "Follow-up behavior",
  "settings.general.row.followup.description": "Choose whether follow-up prompts steer immediately or wait in a queue",
  "settings.general.row.followup.option.queue": "Queue",
  "settings.general.row.followup.option.steer": "Steer",
  "settings.general.row.showFileTree.title": "File tree",
  "settings.general.row.showFileTree.description": "Show the file tree panel in sessions",
  "settings.general.row.showNavigation.title": "Navigation controls",
  "settings.general.row.showNavigation.description": "Show the back and forward buttons in the desktop title bar",
  "settings.general.row.showSearch.title": "Command palette",
  "settings.general.row.showSearch.description": "Show the search and command palette button in the title bar",
  "settings.general.row.showTerminal.title": "Terminal",
  "settings.general.row.showTerminal.description": "Show the terminal button in the desktop title bar",
  "settings.general.row.showStatus.title": "Server status",
  "settings.general.row.showStatus.description": "Show the server status button in the title bar",
  "settings.general.row.mobileTitlebarBottom.title": "Bottom navigation",
  "settings.general.row.mobileTitlebarBottom.description":
    "Place the title bar and session tabs at the bottom of the screen on mobile",
  "settings.general.row.showCustomAgents.title": "Show agent",
  "settings.general.row.showCustomAgents.description":
    "Switch between agents in the composer. When hidden, defaults to Build agent.",
  "settings.general.row.reasoningSummaries.title": "Show reasoning summaries",
  "settings.general.row.reasoningSummaries.description": "Display model reasoning summaries in the timeline",
  "settings.general.row.shellToolPartsExpanded.title": "Expand shell tool parts",
  "settings.general.row.shellToolPartsExpanded.description":
    "Show shell tool parts expanded by default in the timeline",
  "settings.general.row.editToolPartsExpanded.title": "Expand edit tool parts",
  "settings.general.row.editToolPartsExpanded.description":
    "Show edit, write, and patch tool parts expanded by default in the timeline",
  "settings.general.row.newInterface.title": "New layout",
  "settings.general.row.newInterface.badge": "New",
  "settings.general.row.newInterface.description":
    "Use the new tabs and home layout. Switch between layouts for a limited time.",
  "settings.general.row.newInterfaceNotice.title": "You're now using new layout",
  "settings.general.row.newInterfaceNotice.description": "The previous layout is no longer available",
  "settings.general.row.newInterfaceNotice.dismiss": "Dismiss",
  "settings.general.row.pinchZoom.title": "Pinch to zoom",
  "settings.general.row.pinchZoom.description": "Allow trackpad pinch and Ctrl-scroll gestures to zoom",

  "settings.general.row.wayland.title": "Use native Wayland",
  "settings.general.row.wayland.description": "Disable X11 fallback on Wayland. Requires restart.",
  "settings.general.row.wayland.tooltip":
    "On Linux with mixed refresh-rate monitors, native Wayland can be more stable.",

  "settings.general.row.releaseNotes.title": "Release notes",
  "settings.general.row.releaseNotes.description": "Show What's New popups after updates",

  "settings.updates.row.startup.title": "Check for updates on startup",
  "settings.updates.row.startup.description": "Automatically check for updates when OpenCode launches",
  "settings.updates.row.check.title": "Check for updates",
  "settings.updates.row.check.description": "Manually check for updates and install if available",
  "settings.updates.action.checkNow": "Check now",
  "settings.updates.action.checking": "Checking...",
  "settings.updates.action.downloading": "Downloading...",
  "settings.updates.action.installing": "Installing...",
  "settings.updates.toast.latest.title": "You're up to date",
  "settings.updates.toast.latest.description": "You're running the latest version of OpenCode.",
  "sound.option.none": "None",
  "sound.option.alert01": "Alert 01",
  "sound.option.alert02": "Alert 02",
  "sound.option.alert03": "Alert 03",
  "sound.option.alert04": "Alert 04",
  "sound.option.alert05": "Alert 05",
  "sound.option.alert06": "Alert 06",
  "sound.option.alert07": "Alert 07",
  "sound.option.alert08": "Alert 08",
  "sound.option.alert09": "Alert 09",
  "sound.option.alert10": "Alert 10",
  "sound.option.bipbop01": "Bip-bop 01",
  "sound.option.bipbop02": "Bip-bop 02",
  "sound.option.bipbop03": "Bip-bop 03",
  "sound.option.bipbop04": "Bip-bop 04",
  "sound.option.bipbop05": "Bip-bop 05",
  "sound.option.bipbop06": "Bip-bop 06",
  "sound.option.bipbop07": "Bip-bop 07",
  "sound.option.bipbop08": "Bip-bop 08",
  "sound.option.bipbop09": "Bip-bop 09",
  "sound.option.bipbop10": "Bip-bop 10",
  "sound.option.staplebops01": "Staplebops 01",
  "sound.option.staplebops02": "Staplebops 02",
  "sound.option.staplebops03": "Staplebops 03",
  "sound.option.staplebops04": "Staplebops 04",
  "sound.option.staplebops05": "Staplebops 05",
  "sound.option.staplebops06": "Staplebops 06",
  "sound.option.staplebops07": "Staplebops 07",
  "sound.option.nope01": "Nope 01",
  "sound.option.nope02": "Nope 02",
  "sound.option.nope03": "Nope 03",
  "sound.option.nope04": "Nope 04",
  "sound.option.nope05": "Nope 05",
  "sound.option.nope06": "Nope 06",
  "sound.option.nope07": "Nope 07",
  "sound.option.nope08": "Nope 08",
  "sound.option.nope09": "Nope 09",
  "sound.option.nope10": "Nope 10",
  "sound.option.nope11": "Nope 11",
  "sound.option.nope12": "Nope 12",
  "sound.option.yup01": "Yup 01",
  "sound.option.yup02": "Yup 02",
  "sound.option.yup03": "Yup 03",
  "sound.option.yup04": "Yup 04",
  "sound.option.yup05": "Yup 05",
  "sound.option.yup06": "Yup 06",

  "settings.general.notifications.agent.title": "Agent",
  "settings.general.notifications.agent.description":
    "Show system notification when the agent is complete or needs attention",
  "settings.general.notifications.permissions.title": "Permissions",
  "settings.general.notifications.permissions.description": "Show system notification when a permission is required",
  "settings.general.notifications.errors.title": "Errors",
  "settings.general.notifications.errors.description": "Show system notification when an error occurs",

  "settings.general.sounds.agent.title": "Agent",
  "settings.general.sounds.agent.description": "Play sound when the agent is complete or needs attention",
  "settings.general.sounds.permissions.title": "Permissions",
  "settings.general.sounds.permissions.description": "Play sound when a permission is required",
  "settings.general.sounds.errors.title": "Errors",
  "settings.general.sounds.errors.description": "Play sound when an error occurs",

  "settings.shortcuts.title": "Keyboard shortcuts",
  "settings.shortcuts.reset.button": "Reset to defaults",
  "settings.shortcuts.reset.toast.title": "Shortcuts reset",
  "settings.shortcuts.reset.toast.description": "Keyboard shortcuts have been reset to defaults.",
  "settings.shortcuts.conflict.title": "Shortcut already in use",
  "settings.shortcuts.conflict.description": "{{keybind}} is already assigned to {{titles}}.",
  "settings.shortcuts.unassigned": "Unassigned",
  "settings.shortcuts.pressKeys": "Press keys",
  "settings.shortcuts.search.placeholder": "Search shortcuts",
  "settings.shortcuts.search.empty": "No shortcuts found",

  "settings.shortcuts.group.general": "General",
  "settings.shortcuts.group.session": "Session",
  "settings.shortcuts.group.navigation": "Navigation",
  "settings.shortcuts.group.modelAndAgent": "Model and agent",
  "settings.shortcuts.group.terminal": "Terminal",
  "settings.shortcuts.group.prompt": "Prompt",

  "settings.providers.title": "Providers",
  "settings.providers.description": "Provider settings will be configurable here.",
  "settings.providers.section.connected": "Connected providers",
  "settings.providers.connected.empty": "No connected providers",
  "settings.providers.connected.environmentDescription": "Connected from your environment variables",
  "settings.providers.section.popular": "Popular providers",
  "settings.providers.custom.description": "Add an OpenAI-compatible provider by base URL.",
  "settings.providers.tag.environment": "Environment",
  "settings.providers.tag.config": "Config",
  "settings.providers.tag.custom": "Custom",
  "settings.providers.tag.other": "Other",
  "settings.models.title": "Models",
  "settings.models.description": "Model settings will be configurable here.",
  "settings.agents.title": "Agents",
  "settings.agents.description": "Agent settings will be configurable here.",
  "settings.commands.title": "Commands",
  "settings.commands.description": "Command settings will be configurable here.",
  "settings.mcp.title": "MCP",
  "settings.mcp.description": "MCP settings will be configurable here.",

  "settings.permissions.title": "Permissions",
  "settings.permissions.description": "Control what tools the server can use by default.",
  "settings.permissions.section.tools": "Tools",
  "settings.permissions.toast.updateFailed.title": "Failed to update permissions",

  "settings.permissions.action.allow": "Allow",
  "settings.permissions.action.ask": "Ask",
  "settings.permissions.action.deny": "Deny",

  "settings.permissions.tool.read.title": "Read",
  "settings.permissions.tool.read.description": "Reading a file (matches the file path)",
  "settings.permissions.tool.edit.title": "Edit",
  "settings.permissions.tool.edit.description": "Modify files, including edits, writes, and patches",
  "settings.permissions.tool.glob.title": "Glob",
  "settings.permissions.tool.glob.description": "Match files using glob patterns",
  "settings.permissions.tool.grep.title": "Grep",
  "settings.permissions.tool.grep.description": "Search file contents using regular expressions",
  "settings.permissions.tool.list.title": "List",
  "settings.permissions.tool.list.description": "List files within a directory",
  "settings.permissions.tool.bash.title": "Bash",
  "settings.permissions.tool.bash.description": "Run shell commands",
  "settings.permissions.tool.task.title": "Task",
  "settings.permissions.tool.task.description": "Launch sub-agents",
  "settings.permissions.tool.skill.title": "Skill",
  "settings.permissions.tool.skill.description": "Load a skill by name",
  "settings.permissions.tool.lsp.title": "LSP",
  "settings.permissions.tool.lsp.description": "Run language server queries",
  "settings.permissions.tool.todowrite.title": "Todo Write",
  "settings.permissions.tool.todowrite.description": "Update the todo list",
  "settings.permissions.tool.webfetch.title": "Web Fetch",
  "settings.permissions.tool.webfetch.description": "Fetch content from a URL",
  "settings.permissions.tool.websearch.title": "Web Search",
  "settings.permissions.tool.websearch.description": "Search the web",
  "settings.permissions.tool.external_directory.title": "External Directory",
  "settings.permissions.tool.external_directory.description": "Access files outside the project directory",
  "settings.permissions.tool.doom_loop.title": "Doom Loop",
  "settings.permissions.tool.doom_loop.description": "Detect repeated tool calls with identical input",

  "session.delete.failed.title": "Failed to delete session",
  "session.delete.title": "Delete session",
  "session.delete.confirm": 'Delete session "{{name}}"?',
  "session.delete.button": "Delete session",

  "workspace.new": "New workspace",
  "workspace.type.local": "local",
  "workspace.type.sandbox": "sandbox",
  "workspace.create.failed.title": "Failed to create workspace",
  "workspace.delete.failed.title": "Failed to delete workspace",
  "workspace.resetting.title": "Resetting workspace",
  "workspace.resetting.description": "This may take a minute.",
  "workspace.reset.failed.title": "Failed to reset workspace",
  "workspace.reset.success.title": "Workspace reset",
  "workspace.reset.success.description": "Workspace now matches the default branch.",
  "workspace.error.stillPreparing": "Workspace is still preparing",
  "workspace.status.checking": "Checking for unmerged changes...",
  "workspace.status.error": "Unable to verify git status.",
  "workspace.status.clean": "No unmerged changes detected.",
  "workspace.status.dirty": "Unmerged changes detected in this workspace.",
  "workspace.delete.title": "Delete workspace",
  "workspace.delete.confirm": 'Delete workspace "{{name}}"?',
  "workspace.delete.button": "Delete workspace",
  "workspace.reset.title": "Reset workspace",
  "workspace.reset.confirm": 'Reset workspace "{{name}}"?',
  "workspace.reset.button": "Reset workspace",
  "workspace.reset.archived.none": "No active sessions will be archived.",
  "workspace.reset.archived.one": "1 session will be archived.",
  "workspace.reset.archived.many": "{{count}} sessions will be archived.",
  "workspace.reset.note": "This will reset the workspace to match the default branch.",

  "datox.kicker": "Datox Agent",
  "datox.logo.alt": "Datox logo",
  "lesha.logo.alt": "Lesha Bank logo",
  "qnb.logo.alt": "QNB logo",
  "datox.error.contactSupport": "Please contact Datox support if this error continues.",
  "datox.prompt.uploadFiles": "Upload files",
  "datox.prompt.upload.uploading": "Uploading",
  "datox.prompt.upload.uploaded": "Uploaded",
  "datox.prompt.upload.failed": "Failed",
  "datox.prompt.automate.title": "@automate",
  "datox.prompt.automate.description": "Run the previous-period workflow for the current period",
  "datox.prompt.analytics.title": "@analytics",
  "datox.prompt.analytics.description": "Analyze data across all project periods",
  "datox.prompt.dashboard.title": "@dashboard",
  "datox.prompt.dashboard.description": "Build or edit the Dashboard canvas",
  "datox.prompt.placeholder": "I want...",
  "datox.title": "Custom report automation",
  "datox.subtitle": "Create a project, upload source files, and chat with the Datox report agent to extract, transform, and generate customer reports.",
  "datox.apiBase": "API: {{url}}",
  "datox.company.label": "Company",
  "datox.company.option": "{{name}} ({{role}})",
  "datox.projects.title": "Projects",
  "datox.projects.description": "Browse your projects and open one to see its periods.",
  "datox.projects.periodsDescription": "Choose a period to open its chats and start working.",
  "datox.projects.openPeriods": "View periods",
  "datox.projects.noMatches": "No projects match your search.",
  "datox.projects.openWorkflow": "Open workflow",
  "datox.projects.openChats": "Open chats",
  "datox.projects.periodActions": "Period actions",
  "datox.projects.projectActions": "Project actions",
  "datox.projects.details": "Details",
  "datox.projects.createdAt": "Created {{date}}",
  "datox.projects.createdBy": "Created by {{name}}",
  "datox.projects.authorFilter": "Created by",
  "datox.projects.allAuthors": "All authors",
  "datox.projects.myProjects": "My projects",
  "datox.projects.myPeriods": "My periods",
  "datox.projects.unknownAuthor": "Unknown author",
  "datox.projects.updatedAt": "Updated {{date}}",
  "datox.projects.actionError": "Unable to update projects or periods. Please try again.",
  "datox.projects.placeholder": "Project name",
  "datox.project.name": "Project name",
  "datox.project.createTitle": "Create project",
  "datox.project.editPrompt": "Project name",
  "datox.project.deleteTitle": "Delete project",
  "datox.project.deleteConfirm": "Delete project {{name}}?",
  "datox.project.deleteDescription": "This removes the project from your Datox report automation workspace.",
  "datox.profile.signedIn": "Signed in",
  "datox.profile.logout": "Log out",
  "datox.profile.logoutTitle": "Log out",
  "datox.profile.logoutConfirm": "Log out {{user}}?",
  "datox.profile.logoutDescription": "You will need to sign in again to access your report automation workspace.",
  "datox.activity.menu": "Activity logs",
  "datox.activity.title": "Activity logs",
  "datox.activity.search": "Search activity, messages, sessions, files, and audit events",
  "datox.activity.refresh": "Refresh",
  "datox.activity.filter.all": "All activity",
  "datox.activity.filter.audit": "Audit events",
  "datox.activity.filter.message": "Chat messages",
  "datox.activity.count": "{{count}} activity items",
  "datox.activity.empty": "No activity found.",
  "datox.usage.menu": "Usage",
  "datox.usage.title": "Usage",
  "datox.usage.modelTitle": "Datox model usage",
  "datox.usage.lastUpdated": "Last updated {{value}}",
  "datox.usage.projects": "Projects",
  "datox.usage.periods": "Periods",
  "datox.usage.chats": "Chats",
  "datox.usage.files": "Source files",
  "datox.usage.extractions": "Extractions",
  "datox.usage.transformations": "Transformations",
  "datox.usage.outputTables": "Output tables",
  "datox.usage.reports": "Reports",
  "datox.usage.approvals": "Approvals",
  "datox.usage.inputTokens": "Input tokens",
  "datox.usage.outputTokens": "Output tokens",
  "datox.usage.totalTokens": "Total tokens",
  "datox.usage.efficiencyTitle": "Efficiency",
  "datox.usage.successRate": "Success rate",
  "datox.usage.failedRuns": "Failed runs",
  "datox.usage.avgTokensPerChat": "Avg tokens per chat",
  "datox.usage.avgResponseSeconds": "Avg response time",
  "datox.usage.timeSaved": "Estimated time saved",
  "datox.usage.fileStatsTitle": "File processing",
  "datox.usage.images": "Images",
  "datox.usage.pdfs": "PDFs",
  "datox.usage.spreadsheets": "Spreadsheets",
  "datox.usage.documents": "Documents",
  "datox.usage.previewableFiles": "Previewable files",
  "datox.usage.filesWithoutPreview": "Files without preview",
  "datox.usage.byProjectTitle": "Usage by project",
  "datox.usage.byPeriodTitle": "Usage by period",
  "datox.usage.recentRunsTitle": "Recent runs",
  "datox.usage.recentActivityTitle": "Recent activity",
  "datox.usage.trustTitle": "Trust and data sources",
  "datox.usage.project": "Project",
  "datox.usage.period": "Period",
  "datox.usage.time": "Time",
  "datox.usage.prompt": "Prompt",
  "datox.usage.status": "Status",
  "datox.usage.duration": "Duration",
  "datox.usage.emptyTable": "No usage details yet.",
  "datox.navigation.collapse": "Collapse navigation",
  "datox.navigation.expand": "Expand navigation",
  "datox.navigation.files": "Files",
  "datox.chats.title": "Chats",
  "datox.header.openChats": "Open chats",
  "datox.chats.description": "Browse your chats across projects and periods.",
  "datox.chats.empty": "No chats found for these filters.",
  "datox.chats.loadError": "Unable to load chats. Please try again.",
  "datox.chats.openError": "Could not open this chat. Please try again.",
  "datox.chats.search": "Search chats, projects or periods",
  "datox.chats.opening": "Opening chat. Please wait…",
  "datox.chats.open": "Open chat",
  "datox.chats.updated": "Updated",
  "datox.chats.total": "Chats: {{count}}",
  "datox.chats.refresh": "Refresh chats",
  "datox.navigation.myWorkspace": "My workspace",
  "datox.catalog.workflows": "Workflows",
  "datox.catalog.dashboards": "Dashboards",
  "datox.catalog.reports": "Reports",
  "datox.catalog.allProjects": "All projects",
  "datox.catalog.allPeriods": "All periods",
  "datox.catalog.periods": "Periods",
  "datox.catalog.projectWide": "Project-wide",
  "datox.catalog.description.dashboards": "Explore dashboards across your projects and periods.",
  "datox.catalog.description.reports": "Find reports across your projects and periods.",
  "datox.catalog.description.workflows": "Browse reporting workflows and template cases across your projects and periods.",
  "datox.catalog.empty": "No items found for these filters.",
  "datox.catalog.error": "Unable to load items. Please try again.",
  "datox.navigation.toggle": "Toggle navigation",
  "datox.navigation.resize": "Resize navigation",
  "datox.agents.title": "Agents",
  "datox.agents.description": "Manage agents available across your workspace, including their instructions, tools, integrations, and permissions.",
  "datox.agents.add": "Add agent",
  "datox.agents.addShort": "Add",
  "datox.agents.create": "Create agent",
  "datox.agents.createTitle": "Create agent",
  "datox.agents.editTitle": "Edit agent",
  "datox.agents.empty": "Select a project to manage agents, or create an agent when a project is available.",
  "datox.agents.emptyCompact": "Select a project to manage agents.",
  "datox.agents.default": "Default",
  "datox.agents.defaultShort": "Default",
  "datox.agents.builtIn": "Built-in",
  "datox.agents.enabled": "Enabled",
  "datox.agents.disabled": "Disabled",
  "datox.agents.enable": "Enable",
  "datox.agents.disable": "Disable",
  "datox.agents.setDefault": "Set default",
  "datox.agents.template": "Template",
  "datox.agents.name": "Agent name",
  "datox.agents.shortDescription": "Short description",
  "datox.agents.mode": "Mode",
  "datox.agents.mode.primary": "Primary",
  "datox.agents.mode.subagent": "Subagent",
  "datox.agents.mode.all": "Primary and subagent",
  "datox.agents.instructions": "Instructions",
  "datox.agents.tools": "Tools",
  "datox.agents.integrations": "Integrations",
  "datox.agents.permissions": "Permissions",
  "datox.agents.foundation": "Foundation agent",
  "datox.agents.noDescription": "No description provided.",
  "datox.agents.noInstructions": "No instructions provided.",
  "datox.agents.noneEnabled": "None enabled.",
  "datox.agents.tool.readFiles": "Read project files",
  "datox.agents.tool.generateReports": "Generate reports",
  "datox.agents.tool.webSearch": "Web search",
  "datox.agents.tool.approvalWorkflow": "Approval workflow",
  "datox.agents.tool.integrations": "Use integrations",
  "datox.agents.tool.calculations": "Run calculations",
  "datox.agents.permission.read": "Read files",
  "datox.agents.permission.edit": "Edit/write files",
  "datox.agents.permission.websearch": "Web search",
  "datox.agents.permission.webfetch": "Web fetch",
  "datox.agents.permission.bash": "Shell/code execution",
  "datox.agents.permission.skill": "Skills",
  "datox.agents.permission.allow": "Allow",
  "datox.agents.permission.ask": "Ask",
  "datox.agents.permission.deny": "Deny",
  "datox.agents.template.customReport": "Custom Report Agent",
  "datox.agents.template.customReport.description": "Extracts facts, validates inputs, and drafts custom reports from project documents.",
  "datox.agents.template.customReport.instructions": "You are a Datox Custom Report Agent. Help users build compliance, risk, audit, and management reports from project documents. Extract relevant facts, validate inputs, identify missing information, cite available sources, and draft clear report outputs with assumptions and open issues.",
  "datox.agents.template.onboarding": "Corporate Onboarding Agent",
  "datox.agents.template.onboarding.description": "Orchestrates corporate onboarding workflows across KYC documents, checks, approvals, and audit trail.",
  "datox.agents.template.onboarding.instructions": "You are a Datox Corporate Onboarding Agent for banking operations. Process onboarding requests by extracting company facts, validating KYC completeness, checking risk and sanctions requirements, requesting missing data, preparing approval packages, proposing system updates, and summarizing the audit trail. Do not claim real banking-system updates unless a tool confirms them.",
  "datox.agents.template.extraction": "Data Extraction Agent",
  "datox.agents.template.extraction.description": "Extracts structured tables and fields from uploaded files for downstream workflows.",
  "datox.agents.template.extraction.instructions": "You are a Datox Data Extraction Agent. Inspect uploaded project files, identify tables and key fields, normalize extracted data, preserve source context, flag low-confidence values, and produce structured outputs suitable for report generation and validation.",
  "datox.integrations.google-drive": "Google Drive",
  "datox.integrations.one-drive": "OneDrive",
  "datox.integrations.sharepoint-online": "SharePoint",
  "datox.integrations.slack": "Slack",
  "datox.integrations.microsoft-teams": "Microsoft Teams",
  "datox.integrations.salesforce": "Salesforce",
  "datox.period.label": "Period",
  "datox.period.create": "Add period",
  "datox.period.empty": "No periods yet.",
  "datox.period.createTitle": "Create period",
  "datox.period.category": "Period type",
  "datox.period.category.daily": "Daily",
  "datox.period.category.weekly": "Weekly",
  "datox.period.category.monthly": "Monthly",
  "datox.period.category.quarterly": "Quarterly",
  "datox.period.category.half_yearly": "Half-Yearly",
  "datox.period.category.annual": "Yearly",
  "datox.period.period": "Select period",
  "datox.period.year": "Select year",
  "datox.period.date": "Select date",
  "datox.period.week": "Select week",
  "datox.newChat.title": "New chat",
  "datox.chats.startFromWorkflow": "Open a workflow and choose Agent to start a conversation in its context.",
  "datox.workflow.agent": "Agent",
  "datox.workflow.agent.opening": "Opening agent…",
  "datox.workflow.agent.hint": "Open the agent conversation for this workflow and period",
  "datox.workflow.agent.error": "Could not open the workflow agent. Please try again.",
  "datox.newChat.description": "Choose a Datox project and reporting period before starting a chat with agents.",
  "datox.newChat.error": "Could not complete the request. Check your connection and try again.",
  "datox.newChat.project": "Project",
  "datox.newChat.period": "Period",
  "datox.newChat.create": "Create chat",
  "datox.newChat.creating": "Creating...",
  "datox.newChat.noProjects": "Create a project first to start a chat.",
  "datox.newChat.periodRequired.title": "Period required",
  "datox.newChat.periodRequired.description": "Create and choose a period before starting a new chat.",
  "datox.projects.create": "Create",
  "datox.projects.empty": "No projects yet.",
  "datox.projects.role": "{{role}} access",
  "datox.projects.readOnly": "You have read-only access to this project.",
  "datox.files.title": "Source files",
  "datox.files.upload": "Upload",
  "datox.files.uploading": "Uploading...",
  "datox.files.empty": "Upload Excel, PDF, Word, CSV, or JSON files.",
  "datox.files.size": "{{size}} bytes",
  "datox.files.panel.title": "Uploaded files",
  "datox.files.panel.upload": "Upload",
  "datox.files.panel.uploading": "Uploading...",
  "datox.files.panel.filter": "Filter files",
  "datox.files.panel.empty": "No files uploaded for this period.",
  "datox.files.panel.noContext": "Open a Datox chat from a project period to view uploaded files.",
  "datox.files.panel.noFileTitle": "No file selected",
  "datox.files.panel.noFileDescription": "Upload or select a file to preview its contents.",
  "datox.files.panel.noPreview": "No preview available for this file.",
  "datox.files.panel.loadingPreview": "Loading preview…",
  "datox.files.panel.slide": "Slide {{index}}",
  "datox.files.panel.fileMeta": "{{size}} bytes · {{type}}",
  "datox.files.panel.delete": "Delete",
  "datox.files.panel.download": "Download",
  "datox.files.library.description": "All files uploaded across your projects.",
  "datox.files.library.empty": "No uploaded files yet.",
  "datox.files.library.allProjects": "All projects",
  "datox.files.library.projectLevel": "Project level",
  "datox.files.library.filter.all": "All",
  "datox.files.library.filter.documents": "Documents",
  "datox.files.library.filter.images": "Images",
  "datox.files.library.filter.spreadsheets": "Spreadsheets",
  "datox.files.library.modified": "Modified",
  "datox.files.library.name": "Name",
  "datox.files.library.project": "Project",
  "datox.files.library.size": "Size",
  "datox.listing.searchProjects": "Search projects",
  "datox.agents.search": "Search agents and capabilities",
  "datox.agents.statusFilter": "Agent status",
  "datox.agents.all": "All agents",
  "datox.agents.noMatches": "No agents match your search or filters.",
  "datox.agents.actionsFor": "Actions for {{name}}",
  "datox.integrations.search": "Search integrations",
  "datox.integrations.statusFilter": "Connection status",
  "datox.integrations.all": "All integrations",
  "datox.integrations.unknown": "Status unavailable",
  "datox.integrations.checking": "Checking connection…",
  "datox.integrations.comingSoon": "Coming soon",
  "datox.integrations.working": "Please wait…",
  "datox.integrations.loadError": "Connection status could not be loaded. Refresh to try again.",
  "datox.integrations.actionError": "The connection action failed. Please try again.",
  "datox.listing.searchPeriods": "Search periods",
  "datox.listing.searchReports": "Search reports, projects or periods",
  "datox.listing.searchDashboards": "Search dashboards, projects or periods",
  "datox.listing.searchWorkflows": "Search workflows, projects or periods",
  "datox.listing.openDashboard": "Open dashboard",
  "datox.listing.openWorkflow": "Open workflow",
  "datox.projects.openWorkflows": "View workflows",
  "datox.listing.dashboardDraft": "Draft",
  "datox.listing.workflowType": "Workflow type",
  "datox.listing.workflowType.all": "All workflows",
  "datox.listing.workflowType.reporting": "Reporting workspace",
  "datox.listing.workflowType.onboarding": "Customer onboarding",
  "datox.listing.workflowType.risk": "Risk review",
  "datox.listing.results": "Showing {{count}} of {{total}}",
  "datox.listing.clear": "Clear filters",
  "datox.listing.sort": "Sort results",
  "datox.listing.updated": "Recently updated",
  "datox.listing.name": "Name A–Z",
  "datox.listing.view": "Display view",
  "datox.listing.grid": "Grid",
  "datox.listing.list": "List",
  "datox.listing.openReport": "Open report",
  "datox.files.library.totalFiles": "Files: {{count}}",
  "datox.files.library.totalProjects": "Projects: {{count}}",
  "datox.files.library.refresh": "Refresh files",
  "datox.files.library.search": "Search files or projects",
  "datox.files.library.fileType": "File type",
  "datox.files.library.location": "File location",
  "datox.files.library.view": "File browsing view",
  "datox.files.library.view.folders": "Folders",
  "datox.files.library.view.files": "All files",
  "datox.files.library.sort": "Sort files",
  "datox.files.library.sort.newest": "Newest first",
  "datox.files.library.sort.name": "Name A–Z",
  "datox.files.library.sort.size": "Largest first",
  "datox.files.library.actions": "Actions",
  "datox.files.library.actionsNamed": "Actions for {{name}}",
  "datox.files.library.projectFolder": "Project folder",
  "datox.files.library.periodFolder": "Period folder",
  "datox.files.library.open": "Open",
  "datox.files.library.noMatches": "No files match your search or filters.",
  "datox.files.library.clearFilters": "Clear filters",
  "datox.files.library.downloadNamed": "Download {{name}}",
  "datox.files.library.actionError": "The file action failed. Please try again.",
  "datox.pipeline.files": "Files",
  "datox.pipeline.workspace.stages": "Workflow stages",
  "datox.pipeline.workspace.openChats": "Open chats",
  "datox.pipeline.workspace.loadError": "This workflow stage could not be loaded. Refresh to try again.",
  "datox.pipeline.workspace.upload": "Upload files",
  "datox.pipeline.workspace.uploading": "Uploading files…",
  "datox.pipeline.workspace.refresh": "Refresh",
  "datox.pipeline.workspace.fileError": "The file operation could not be completed. Refresh and try again.",
  "datox.pipeline.workspace.noFilesMatch": "No matching source files",
  "datox.pipeline.workspace.sourceTitle": "Start with your source files",
  "datox.pipeline.workspace.sourceHint": "Upload documents for this workflow, or select an existing file to preview its contents. You can also drag files into this area.",
  "datox.pipeline.workspace.noResults": "No matching results",
  "datox.pipeline.workspace.extractionHint": "Upload source files, then run extraction in the workflow chat. Saved extraction results will appear here for review.",
  "datox.pipeline.workspace.transformationHint": "Run a transformation on the extracted data in the workflow chat. Saved calculations and tables will appear here.",
  "datox.pipeline.workspace.outputHint": "Output tables appear after the workflow saves transformed data. Check the transformation results or clear the report filter.",
  "datox.pipeline.workspace.viewFiles": "View source files",
  "datox.pipeline.workspace.viewExtractions": "View extractions",
  "datox.pipeline.workspace.viewTransformations": "View transformations",
  "datox.pipeline.workspace.viewReports": "View reports",
  "datox.pipeline.workspace.approvalTitle": "A report is needed before review",
  "datox.pipeline.workspace.approvalHint": "Generate a report from this workflow, then return here to select it and invite reviewers.",
  "datox.pipeline.workspace.searchCategories": "Search categories or fields",
  "datox.pipeline.workspace.copied": "Copied",
  "datox.pipeline.workspace.copyError": "Could not copy the table. You can download it as CSV instead.",
  "datox.pipeline.extractions": "Extractions",
  "datox.pipeline.transformations": "Transformations",
  "datox.pipeline.output": "Output",
  "datox.pipeline.report": "Report",
  "datox.pipeline.report.refresh": "Refresh report",
  "datox.pipeline.report.download": "Download",
  "datox.pipeline.report.openPreview": "Open preview",
  "datox.pipeline.report.opening": "Opening report",
  "datox.pipeline.report.loadingHint": "Loading the report workspace. Please wait…",
  "datox.pipeline.report.copyPreviewLink": "Copy link",
  "datox.pipeline.report.linkCopied": "Link copied",
  "datox.pipeline.report.copyFailed": "Could not copy the link. Open the preview and copy its address from your browser.",
  "datox.pipeline.report.previewAccess": "Live report preview · Project access required",
  "datox.pipeline.report.previewError": "The report could not be loaded. Check your project access, or refresh to try again.",
  "datox.pipeline.report.export": "Export as",
  "datox.pipeline.report.share": "Share",
  "datox.pipeline.report.export.html": "Export as HTML",
  "datox.pipeline.report.export.pdf": "Export as PDF",
  "datox.pipeline.report.generatingPDF": "Generating PDF…",
  "datox.pipeline.report.export.txt": "Export as text",
  "datox.pipeline.report.export.json": "Export as JSON",
  "datox.pipeline.report.export.csv": "Export as CSV",
  "datox.pipeline.report.delete": "Delete",
  "datox.pipeline.report.deleteTitle": "Delete report",
  "datox.pipeline.report.deleteConfirm": "Delete “{{title}}”?",
  "datox.pipeline.report.deleteDescription": "This report will be removed from the workspace.",
  "datox.pipeline.report.deleteError": "Could not delete the report. Please try again.",
  "datox.pipeline.report.deleting": "Deleting…",
  "datox.pipeline.report.template.import": "Import HTML template",
  "datox.pipeline.report.template.invalid": "Choose an HTML template file.",
  "datox.pipeline.report.template.failed": "Failed to import template.",
  "datox.pipeline.report.template.badge": "Template",
  "datox.pipeline.report.previewScale": "Preview scale {{scale}}",
  "datox.pipeline.report.documentPreview": "Document preview",
  "datox.pipeline.report.fitWidth": "Fit width",
  "datox.pipeline.report.actualSize": "Actual size (100%)",
  "datox.pipeline.report.chooseReport": "Choose a report",
  "datox.pipeline.report.availableCount": "Available reports: {{count}}",
  "datox.pipeline.report.downloading": "Downloading…",
  "datox.pipeline.report.exporting": "Exporting…",
  "datox.pipeline.report.actionError": "The download or export failed. Please try again.",
  "datox.pipeline.report.zoomIn": "Zoom in",
  "datox.pipeline.report.zoomOut": "Zoom out",
  "datox.pipeline.report.previewUnavailable": "Preview is not available for this file type. Download the report to view it.",
  "datox.pipeline.report.pdfLoading": "PDF preview is loading...",
  "datox.pipeline.approval": "Approval",
  "datox.pipeline.openFullView": "Open full view",
  "datox.pipeline.exitFullView": "Exit full view",
  "datox.dashboard.title": "Dashboard",
  "datox.dashboard.defaultName": "Untitled dashboard",
  "datox.dashboard.loading": "Loading dashboard...",
  "datox.dashboard.createTitle": "Create dashboard",
  "datox.dashboard.create": "Create dashboard",
  "datox.dashboard.renameDashboard": "Rename dashboard",
  "datox.dashboard.deleteDashboard": "Delete dashboard",
  "datox.dashboard.deleteDashboardConfirm": "This dashboard will be deleted. This action cannot be undone.",
  "datox.dashboard.preview": "Preview",
  "datox.dashboard.publishedStatus": "Published",
  "datox.dashboard.unpublishedStatus": "Unpublished",
  "datox.dashboard.publishDashboard": "Publish",
  "datox.dashboard.unpublishDashboard": "Unpublish",
  "datox.dashboard.publishDashboardCopied": "Dashboard published.",
  "datox.dashboard.openLink": "Open link",
  "datox.dashboard.copyLink": "Copy link",
  "datox.dashboard.copied": "Copied",
  "datox.dashboard.clients": "Clients",
  "datox.dashboard.clientsDescription": "Choose the output table and column that define client-specific rows.",
  "datox.dashboard.client": "Client",
  "datox.dashboard.clientTable": "Client table",
  "datox.dashboard.clientColumn": "Client column",
  "datox.dashboard.clientValues": "Client values",
  "datox.dashboard.noClientValues": "No values found for this column.",
  "datox.dashboard.allClients": "All clients",
  "datox.dashboard.column": "Column",
  "datox.dashboard.exportMenu": "Export",
  "datox.dashboard.exportPdf": "Export PDF",
  "datox.dashboard.shareAccess": "Share Access",
  "datox.dashboard.reviewers": "Reviewers",
  "datox.dashboard.reviewerName": "Reviewer Name",
  "datox.dashboard.reviewerEmail": "Reviewer Email",
  "datox.dashboard.reports": "Reports",
  "datox.dashboard.reviewStatus": "Status",
  "datox.dashboard.notSent": "Not Sent",
  "datox.dashboard.sent": "Sent",
  "datox.dashboard.duplicateEmail": "Duplicate email",
  "datox.dashboard.addAnotherReviewer": "Add Another Reviewer",
  "datox.dashboard.reviewersPlaceholder": "Reviewer email",
  "datox.dashboard.sendShareAccess": "Send access",
  "datox.dashboard.sendingShareAccess": "Sending...",
  "datox.dashboard.tidyLayout": "Tidy layout",
  "datox.dashboard.renameTab": "Rename tab",
  "datox.dashboard.duplicateTab": "Duplicate",
  "datox.dashboard.deleteTab": "Delete",
  "datox.dashboard.rename": "Rename",
  "datox.dashboard.nameField": "Name",
  "datox.dashboard.doubleClickRename": "Double-click to rename",
  "datox.dashboard.save": "Save dashboard",
  "datox.dashboard.saving": "Saving...",
  "datox.dashboard.error": "Dashboard update failed.",
  "datox.dashboard.emptyTitle": "Create your first dashboard",
  "datox.dashboard.emptyDescription": "Build a canvas from the Output tables saved in this period.",
  "datox.dashboard.widgets": "Widgets",
  "datox.dashboard.data": "Data",
  "datox.dashboard.design": "Design",
  "datox.dashboard.dataset": "Output table",
  "datox.dashboard.source": "Source",
  "datox.dashboard.rows": "Rows",
  "datox.dashboard.columns": "Columns",
  "datox.dashboard.tableMetadata": "Table metadata",
  "datox.dashboard.columnMetadata": "Column metadata",
  "datox.dashboard.tablePreview": "Table preview",
  "datox.dashboard.closePanel": "Close panel",
  "datox.dashboard.openPanel": "Open panel",
  "datox.dashboard.panel": "Panel",
  "datox.dashboard.newTabName": "Tab {count}",
  "datox.dashboard.searchWidgets": "Search widgets...",
  "datox.dashboard.listView": "List view",
  "datox.dashboard.gridView": "Grid view",
  "datox.dashboard.widgetLibrary": "Widget library",
  "datox.dashboard.name": "Dashboard name",
  "datox.dashboard.namePlaceholder": "Dashboard name",
  "datox.dashboard.removeWidget": "Remove widget",
  "datox.dashboard.canvasEmpty": "Add widgets from the sidebar to start building this dashboard.",
  "datox.dashboard.defaultTabName": "Tab 1",
  "datox.dashboard.emptyCanvasTitle": "Empty canvas",
  "datox.dashboard.emptyCanvasDescription": "Drag a widget from the left widgets panel onto this canvas to start building this tab.",
  "datox.dashboard.accentColor": "Accent color",
  "datox.dashboard.selectedWidgetTitle": "Selected widget title",
  "datox.dashboard.textContent": "Text content",
  "datox.dashboard.titleContent": "Title content",
  "datox.dashboard.editText": "Edit text",
  "datox.dashboard.widgetDataset": "Widget dataset",
  "datox.dashboard.metricColumn": "Metric column",
  "datox.dashboard.summarize": "Summarize",
  "datox.dashboard.aggregation": "Aggregation",
  "datox.dashboard.aggregationSum": "Sum",
  "datox.dashboard.aggregationAverage": "Average",
  "datox.dashboard.aggregationMin": "Minimum",
  "datox.dashboard.aggregationMax": "Maximum",
  "datox.dashboard.aggregationCount": "Count",
  "datox.dashboard.aggregationFirst": "First",
  "datox.dashboard.aggregationLast": "Last",
  "datox.dashboard.labelColumn": "Label column",
  "datox.dashboard.editWidget": "Edit widget",
  "datox.dashboard.renameWidget": "Rename widget",
  "datox.dashboard.editData": "Edit data",
  "datox.dashboard.editDesign": "Edit design",
  "datox.dashboard.exportTable": "Export table",
  "datox.dashboard.fullView": "Full view",
  "datox.dashboard.widgetType": "Widget type",
  "datox.dashboard.sampleData": "Sample data",
  "datox.dashboard.filter": "Filter",
  "datox.dashboard.addFilter": "Add filter",
  "datox.dashboard.noFiltersApplied": "No filters applied.",
  "datox.dashboard.filterContains": "Contains",
  "datox.dashboard.filterEquals": "Equals",
  "datox.dashboard.filterNotEmpty": "Not empty",
  "datox.dashboard.filterTargets": "Filter target tables",
  "datox.dashboard.sort": "Sort",
  "datox.dashboard.noSort": "No sort",
  "datox.dashboard.sortAscending": "Ascending",
  "datox.dashboard.sortDescending": "Descending",
  "datox.dashboard.rowLimit": "Row limit",
  "datox.dashboard.noRowLimit": "No limit",
  "datox.dashboard.chartData": "Chart data",
  "datox.dashboard.groupBy": "Group by",
  "datox.dashboard.groupByHelp": "One point or category per value in this column",
  "datox.dashboard.dataStreams": "Data streams",
  "datox.dashboard.dataStreamsHelp": "Choose two or more numeric columns to plot",
  "datox.dashboard.dataStreamDisplayNames": "Data stream display names",
  "datox.dashboard.showTop": "Show top",
  "datox.dashboard.by": "by",
  "datox.dashboard.order": "order",
  "datox.dashboard.logo": "Logo",
  "datox.dashboard.uploadLogo": "Upload logo",
  "datox.dashboard.headerColor": "Header color",
  "datox.dashboard.cornerRadius": "Corner radius",
  "datox.dashboard.radiusSquare": "Square",
  "datox.dashboard.radiusMedium": "M",
  "datox.dashboard.radiusLarge": "L",
  "datox.dashboard.fontSize": "Font size",
  "datox.dashboard.fontWeight": "Font weight",
  "datox.dashboard.textColor": "Text color",
  "datox.dashboard.textAlign": "Text align",
  "datox.dashboard.verticalAlign": "Vertical align",
  "datox.dashboard.alignLeft": "Left",
  "datox.dashboard.alignCenter": "Center",
  "datox.dashboard.alignRight": "Right",
  "datox.dashboard.alignTop": "Top",
  "datox.dashboard.alignMiddle": "Middle",
  "datox.dashboard.alignBottom": "Bottom",
  "datox.dashboard.fontCompact": "Compact",
  "datox.dashboard.fontNormal": "Normal",
  "datox.dashboard.fontLarge": "Large",
  "datox.dashboard.headingFont": "Heading font",
  "datox.dashboard.bodyFont": "Body font",
  "datox.dashboard.widgetShadows": "Widget shadows",
  "datox.dashboard.lightGrayBackground": "Light gray background",
  "datox.dashboard.tableDensity": "Table density",
  "datox.dashboard.showTableHeader": "Show table header",
  "datox.dashboard.stripedRows": "Striped rows",
  "datox.dashboard.headerFill": "Header fill",
  "datox.dashboard.filterDisplay": "Filter display",
  "datox.dashboard.filterDisplayChips": "Chips",
  "datox.dashboard.filterDisplayList": "List",
  "datox.dashboard.filterDisplayDropdown": "Dropdown",
  "datox.dashboard.allowMultipleValues": "Allow multiple values",
  "datox.dashboard.chartOrientation": "Chart orientation",
  "datox.dashboard.chartType": "Chart type",
  "datox.dashboard.chartSection": "Chart",
  "datox.dashboard.labelsSection": "Labels",
  "datox.dashboard.donutChart": "Donut (hollow center)",
  "datox.dashboard.showValuesNextToLabels": "Show values next to labels",
  "datox.dashboard.vertical": "Vertical",
  "datox.dashboard.horizontal": "Horizontal",
  "datox.dashboard.showLegend": "Show legend",
  "datox.dashboard.showValueLabels": "Show value labels",
  "datox.dashboard.showAxisLabels": "Show axis labels",
  "datox.dashboard.showGridLines": "Show grid lines",
  "datox.dashboard.distinctBarColors": "Distinct bar colors",
  "datox.dashboard.stackSeries": "Stack series",
  "datox.dashboard.xAxisLabel": "X-axis label",
  "datox.dashboard.yAxisLabel": "Y-axis label",
  "datox.dashboard.valueFormat": "Value format",
  "datox.dashboard.numberFormat": "Number",
  "datox.dashboard.integerFormat": "Integer",
  "datox.dashboard.percentFormat": "Percent",
  "datox.dashboard.decimalPlaces": "Decimal places",
  "datox.dashboard.duplicateWidget": "Duplicate widget",
  "datox.dashboard.deleteWidget": "Delete widget",
  "datox.dashboard.copySuffix": "Copy",
  "datox.dashboard.metricFallback": "Metric",
  "datox.dashboard.itemLabel": "Item {count}",
  "datox.dashboard.valueLabel": "Value",
  "datox.dashboard.portrait": "Portrait",
  "datox.dashboard.landscape": "Landscape",
  "datox.dashboard.pdf.preview": "PDF preview",
  "datox.dashboard.pdf.orientation": "Orientation",
  "datox.dashboard.pdf.margin": "Margin",
  "datox.dashboard.pdf.textSize": "Text size",
  "datox.dashboard.pdf.scale": "Scale: {value}%",
  "datox.dashboard.pdf.gray": "Light gray background",
  "datox.dashboard.pdf.allRows": "Include complete tables",
  "datox.dashboard.pdf.tableDensity": "Table density",
  "datox.dashboard.pdf.original": "Original",
  "datox.dashboard.pdf.compact": "Compact",
  "datox.dashboard.pdf.normal": "Normal",
  "datox.dashboard.pdf.large": "Large",
  "datox.dashboard.pdf.accent": "Accent color",
  "datox.dashboard.pdf.widgetAdjustments": "Widget adjustments",
  "datox.dashboard.pdf.widgetHelp": "Drag or resize a widget in the preview to adjust its PDF layout.",
  "datox.dashboard.pdf.widgetSelect": "Widget",
  "datox.dashboard.pdf.widgetTitleSize": "Title size: {value}px",
  "datox.dashboard.pdf.widgetContentSize": "Content size: {value}px",
  "datox.dashboard.pdf.kpiScale": "KPI value scale: {value}%",
  "datox.dashboard.pdf.widgetReset": "Reset widget",
  "datox.dashboard.undo": "Undo",
  "datox.dashboard.redo": "Redo",
  "datox.dashboard.drag": "Drag",
  "datox.dashboard.more": "More",
  "datox.dashboard.widgetCount": "{count} widgets",
  "datox.dashboard.tabCount": "{count} tabs",
  "datox.dashboard.allChangesSaved": "All changes saved",
  "datox.dashboard.somethingWentWrong": "Something went wrong",
  "datox.publicDashboard.profile": "Profile",
  "datox.publicDashboard.loading": "Loading dashboard...",
  "datox.publicDashboard.notFound": "Dashboard not found or unpublished.",
  "datox.dashboard.textPlaceholder": "Add commentary or context for this section.",
  "datox.dashboard.widget.header": "Header",
  "datox.dashboard.widget.text": "Text block",
  "datox.dashboard.widget.title": "Title",
  "datox.dashboard.widget.kpi": "KPI card",
  "datox.dashboard.widget.table": "Table",
  "datox.dashboard.widget.freeTable": "Free style table",
  "datox.dashboard.widget.bar": "Bar chart",
  "datox.dashboard.widget.line": "Line chart",
  "datox.dashboard.widget.scatter": "Scatter chart",
  "datox.dashboard.widget.pie": "Pie chart",
  "datox.dashboard.widget.heatmap": "Heatmap",
  "datox.dashboard.widget.multiSeries": "Multi-series chart",
  "datox.dashboard.widget.treemap": "Treemap",
  "datox.dashboard.widget.funnel": "Funnel",
  "datox.dashboard.widget.filter": "Filter",
  "datox.approval.description": "Prepare, route, and track report review decisions across assigned reviewers.",
  "datox.approval.notRequested": "Not requested",
  "datox.approval.viewReport": "View report",
  "datox.approval.reviewersTitle": "Reviewers and decisions",
  "datox.approval.reportScoped": "For the selected report",
  "datox.approval.search": "Search reviewers or feedback",
  "datox.approval.noReviewers": "No reviewers yet",
  "datox.approval.noReviewersHint": "Add reviewer emails to send the first review request for this report.",
  "datox.approval.noMatches": "Try another search or clear the status filter.",
  "datox.approval.addReviewers": "Add reviewers",
  "datox.approval.updatedAt": "Updated {{date}}",
  "datox.approval.copyReviewLink": "Copy review link",
  "datox.approval.linkCopied": "Link copied",
  "datox.approval.removeReviewer": "Remove reviewer",
  "datox.approval.messageAndFeedback": "Message and feedback",
  "datox.approval.messageOptional": "Add a message (optional)",
  "datox.approval.emailHint": "Separate email addresses with commas, semicolons, or new lines.",
  "datox.approval.invalidEmails": "Check these email addresses: {{emails}}",
  "datox.approval.alreadyAssigned": "This email is already assigned to the report.",
  "datox.approval.skippingAssigned": "Already assigned reviewers will be skipped.",
  "datox.approval.sent": "Review requests sent. You can track each decision below.",
  "datox.approval.updated": "Reviewer updated.",
  "datox.approval.removed": "Reviewer removed.",
  "datox.approval.requestError": "Could not send the review requests. Check the reviewer list before trying again.",
  "datox.approval.updateError": "Could not update the reviewer. Please try again.",
  "datox.approval.deleteError": "Could not remove the reviewer. Please try again.",
  "datox.approval.copyError": "Could not copy the review link. Please try again.",
  "datox.approval.requestReview": "Request review",
  "datox.approval.editReviewers": "Edit reviewers",
  "datox.approval.doneEditing": "Done editing",
  "datox.approval.request.title": "Request report review",
  "datox.approval.request.description": "Send reviewers a dedicated link where they can view only the generated report and record their decision.",
  "datox.approval.request.report": "Report",
  "datox.approval.request.reviewers": "Reviewer emails",
  "datox.approval.request.reviewers.placeholder": "name@example.com, reviewer@example.com",
  "datox.approval.request.message": "Message",
  "datox.approval.request.message.placeholder": "Optional note for reviewers",
  "datox.approval.request.sending": "Sending...",
  "datox.approval.metric.reviewers": "Reviewers",
  "datox.approval.metric.pending": "Pending",
  "datox.approval.metric.approved": "Approved",
  "datox.approval.metric.rejected": "Rejected",
  "datox.approval.package.title": "Approval package",
  "datox.approval.package.description": "Share the generated report, evidence, and decision request with reviewers.",
  "datox.approval.check.report": "Report generated",
  "datox.approval.check.reviewers": "Reviewers assigned",
  "datox.approval.check.audit": "Audit trail ready",
  "datox.approval.check.status.complete": "Complete",
  "datox.approval.check.status.pending": "Pending",
  "datox.approval.table.reviewer": "Reviewer",
  "datox.approval.table.required": "Required",
  "datox.approval.table.status": "Status",
  "datox.approval.table.updated": "Last updated",
  "datox.approval.reviewer.role": "Report reviewer",
  "datox.approval.status.approved": "Approved",
  "datox.approval.status.rejected": "Rejected",
  "datox.approval.status.viewed": "Viewed",
  "datox.approval.status.pending": "Pending",
  "datox.approval.timeline.title": "Workflow timeline",
  "datox.approval.timeline.reportReady": "Report package ready",
  "datox.approval.timeline.reviewersAssigned": "Reviewers assigned",
  "datox.approval.timeline.awaitingReview": "Awaiting reviewer decision",
  "datox.approval.timeline.finalDecision": "Final decision captured",
  "datox.approval.timeline.status.complete": "Complete",
  "datox.approval.timeline.status.working": "In progress",
  "datox.approval.timeline.status.pending": "Pending",
  "datox.approval.comments.title": "Reviewer comments",
  "datox.approval.comments.empty": "No reviewer comments yet.",
  "datox.review.loading": "Loading review...",
  "datox.review.workspaceTitle": "Report review",
  "datox.review.requesterFallback": "the Datox team",
  "datox.review.reportTitle": "Report",
  "datox.review.fullPage": "Full page",
  "datox.review.backToReview": "Back to review",
  "datox.review.download": "Download report",
  "datox.review.downloading": "Downloading…",
  "datox.review.exportPdf": "Export PDF",
  "datox.review.openingPrint": "Opening print dialog…",
  "datox.review.printHint": "Choose “Save as PDF” as the destination in your browser's print dialog. The report's print layout will be used.",
  "datox.review.printError": "Could not open the print dialog. Download the report and print it from your browser instead.",
  "datox.review.downloadError": "Could not download the report. Please try again.",
  "datox.review.previewError": "Could not load the preview. You can still download the report.",
  "datox.review.previewUnavailable": "A preview is not available for this file type. Download the report to review it.",
  "datox.review.loadError": "This review could not be loaded",
  "datox.review.loadErrorHint": "Try again, or ask the sender to check that your review link is still available.",
  "datox.review.decision.instructions": "Read the report, add any feedback, and record your decision.",
  "datox.review.unsaved": "Unsaved changes",
  "datox.review.saveError": "Could not save your review. Your comments are still here; please try again.",
  "datox.review.saved.comments": "Your comments have been saved.",
  "datox.review.saved.approved": "Your approval has been recorded.",
  "datox.review.saved.rejected": "Your rejection has been recorded.",
  "datox.review.subtitle": "Review requested for {{email}}",
  "datox.review.requestedBy": "Requested by {{user}}",
  "datox.review.loadingReport": "Loading report...",
  "datox.review.decision.title": "Review decision",
  "datox.review.decision.description": "Review the report below, add optional comments, then approve or reject the report.",
  "datox.review.comments": "Comments",
  "datox.review.comments.placeholder": "Add comments for the Datox team",
  "datox.review.saveComments": "Save comment",
  "datox.review.savingComments": "Saving...",
  "datox.review.approve": "Approve",
  "datox.review.approving": "Approving...",
  "datox.review.reject": "Reject",
  "datox.review.rejecting": "Rejecting...",
  "datox.review.status.approved": "Approved",
  "datox.review.status.rejected": "Rejected",
  "datox.review.status.pending": "Pending",
  "datox.pipeline.extraction.empty": "No extracted tables have been saved for this period yet.",
  "datox.pipeline.extraction.noTable": "No table data available for this extraction.",
  "datox.pipeline.extraction.loading": "Loading extraction data",
  "datox.pipeline.extraction.loadingHint": "Preparing tables for preview. Large datasets may take a moment.",
  "datox.pipeline.extraction.refreshing": "Refreshing extraction data…",
  "datox.pipeline.extraction.pagedHint": "Preview is paginated; the CSV download includes the complete table.",
  "datox.pipeline.table.range": "Rows {{start}}–{{end}} of {{total}}",
  "datox.pipeline.table.pageSize": "Rows per page",
  "datox.pipeline.table.page": "Page {{current}} of {{total}}",
  "datox.pipeline.table.goToPage": "Go to page",
  "datox.pipeline.table.previous": "Previous",
  "datox.pipeline.table.next": "Next",
  "datox.pipeline.extraction.categorySummary": "{{tables}} tables · {{rows}} rows",
  "datox.pipeline.extraction.tables": "Tables",
  "datox.pipeline.extraction.table": "Table",
  "datox.pipeline.extraction.tableMeta": "{{rows}} rows · {{columns}} columns",
  "datox.pipeline.transformation.empty": "No transformed outputs have been saved for this period yet.",
  "datox.pipeline.transformation.sources": "Source tables",
  "datox.pipeline.transformation.steps": "Transformation steps",
  "datox.pipeline.transformation.validations": "Validation checks",
  "datox.pipeline.transformation.assumptions": "Assumptions",
  "datox.pipeline.transformation.preview": "Output preview",
  "datox.pipeline.records.count": "{{count}} records",
  "datox.pipeline.records.latest": "Latest",
  "datox.pipeline.records.search": "Search records",
  "datox.pipeline.records.allStatuses": "All statuses",
  "datox.pipeline.records.tables": "tables",
  "datox.pipeline.records.metric.tables": "Tables",
  "datox.pipeline.records.metric.status": "Status",
  "datox.pipeline.records.metric.sourceFile": "Source file",
  "datox.pipeline.records.metric.created": "Created",
  "datox.pipeline.records.metric.updated": "Updated",
  "datox.pipeline.output.empty": "No final output tables have been saved for this period yet.",
  "datox.pipeline.output.count": "{{count}} output tables",
  "datox.pipeline.output.rows": "rows",
  "datox.pipeline.output.columns": "columns",
  "datox.pipeline.output.version": "Version",
  "datox.pipeline.output.reportUsage": "Report usage",
  "datox.pipeline.output.filterByReport": "Filter by report",
  "datox.pipeline.output.allReports": "All reports",
  "datox.pipeline.output.notUsedInReport": "Not used in a report",
  "datox.pipeline.output.usedInReport": "Used in {{title}}",
  "datox.pipeline.output.usedInReports": "Used in {{count}} reports",
  "datox.pipeline.output.sourceTransformation": "Source transformation",
  "datox.pipeline.output.copy": "Copy table",
  "datox.pipeline.output.downloadCsv": "Download CSV",
  "datox.pipeline.output.search": "Search within selected table",
  "datox.pipeline.report.empty": "No generated report has been saved for this period yet.",
  "datox.pipeline.approval.empty": "No approval request has been created for this period yet.",
  "settings.section.datox": "Datox",
  "datox.admin.title": "Admin",
  "datox.admin.description": "Manage companies in this environment. Switching companies changes the data you see across Cowork.",
  "datox.admin.companyName": "Company name",
  "datox.admin.edit": "Edit name",
  "datox.admin.create": "Create company",
  "datox.admin.save": "Save name",
  "datox.admin.switch": "Switch to company",
  "datox.admin.current": "Current company",
  "datox.admin.archive": "Archive",
  "datox.admin.confirmArchive": "Confirm archive",
  "datox.admin.cancel": "Cancel",
  "datox.admin.restore": "Restore",
  "datox.admin.archived": "Archived",
  "datox.admin.archiveNotice": "Archiving removes access and stops scheduled automations. Data is retained and can be restored.",
  "datox.admin.loadFailed": "Could not load companies. Try again.",
  "datox.admin.actionFailed": "Could not update the company. Try again.",
  "datox.admin.empty": "No companies yet. Create the first company above.",
  "datox.company.default": "Datox",
  "datox.company.noAccess": "You do not have access to an active company. Ask your company admin to invite you.",
  "datox.members.title": "Members",
  "datox.members.intro": "Choose who can access your projects and what they can do.",
  "datox.members.scope": "Access scope",
  "datox.members.scope.project": "Project members",
  "datox.members.scope.project.description": "Invite a teammate to one project as a viewer or editor.",
  "datox.members.scope.company": "Company admins",
  "datox.members.scope.company.description": "Give admin access to every current and future project.",
  "datox.members.company.current": "People with company-wide access",
  "datox.members.current": "Project members",
  "datox.members.role.owner": "Owner",
  "datox.members.you": "You",
  "datox.members.inheritedAccess": "Company admins also have access to this project through their company role.",
  "datox.members.retry": "Try again",
  "datox.members.identityFailed": "Could not load your company permissions.",
  "datox.members.projectsFailed": "Could not load projects.",
  "datox.members.loadFailed": "Could not load members. Try again to see the latest access list.",
  "datox.members.noProjects": "No projects are available. Create a project or ask an admin for access.",
  "datox.members.requestFailed": "The request could not be completed. Please try again.",
  "datox.members.removeNamed": "Remove {{name}} from this project",
  "datox.members.removing": "Removing...",
  "datox.members.removed": "Project membership removed for {{name}}.",
  "datox.members.projectOnly": "Access applies to {{project}} only.",
  "datox.members.projectUpdated": "Access to {{project}} updated for {{identifier}}.",
  "datox.members.company.title": "Company admins",
  "datox.members.company.permissionRequired": "A company admin or owner can invite company admins. Project ownership alone does not grant this permission. Ask an existing company admin to update your company role.",
  "datox.members.company.currentRole": "Your current company role: {{role}}.",
  "datox.members.company.refreshPermissions": "Refresh permissions",
  "datox.members.company.description": "Company admins can manage every project in this company, including projects created later. Invite an admin by email address.",
  "datox.members.company.email": "Admin email address",
  "datox.members.company.placeholder": "name@example.com",
  "datox.members.company.add": "Add company admin",
  "datox.members.company.adding": "Adding admin...",
  "datox.members.company.invited": "Admin access updated for {{email}}.",
  "datox.members.company.error": "Could not add company admin",
  "datox.members.company.role.admin": "Admin",
  "datox.members.company.role.owner": "Owner",
  "datox.members.project.readOnly": "Only project owners and company admins can manage project members.",
  "datox.members.project.readOnly.description": "Ask a project owner or company admin to invite or remove members.",
  "datox.members.project": "Project",
  "datox.members.project.description": "Choose the project whose members you want to manage.",
  "datox.members.invite": "Invite member",
  "datox.members.invite.description": "Invite a teammate by email address or user ID and choose their project role.",
  "datox.members.identifier": "Email address or user ID",
  "datox.members.role": "Project role",
  "datox.members.role.viewer.description": "Viewers can access this project's content without making changes.",
  "datox.members.role.editor.description": "Editors can work on this project's content.",
  "datox.members.invite.hint": "Email invitations are sent to new members.",
  "datox.members.invited": "Access updated for {{identifier}}.",
  "datox.members.placeholder": "User ID or email",
  "datox.members.add": "Add",
  "datox.members.adding": "Adding...",
  "datox.members.remove": "Remove",
  "datox.members.empty": "No project members yet.",
  "datox.members.empty.description": "Invited project members will appear here.",
  "datox.members.readOnly": "Only project owners can manage members.",
  "datox.members.readOnly.description": "Ask a project owner to invite or remove members.",
  "datox.members.error": "Member update failed",
  "datox.members.role.viewer": "Viewer",
  "datox.members.role.editor": "Editor",
  "datox.integrations.menu": "Integrations",
  "datox.integrations.title": "Integrations",
  "datox.integrations.description": "Connect cloud drives, collaboration tools, CRMs, and workflow systems so Datox Agent can use them as source context.",
  "datox.integrations.available": "Available",
  "datox.integrations.planned": "Planned",
  "datox.integrations.connected": "Connected",
  "datox.integrations.managed": "Administrator-managed",
  "datox.integrations.managedByAdmin": "Managed by your administrator",
  "datox.integrations.alphaDeskProjects": "Available in: {{projects}}",
  "datox.integrations.description.alphaDesk": "Import reporting-period Excel files from configured Alpha Desk projects.",
  "datox.integrations.connect": "Connect",
  "datox.integrations.disconnect": "Disconnect",
  "datox.integrations.refresh": "Refresh connections",
  "datox.integrations.import.description": "Choose files from connected integrations and import them into this chat.",
  "datox.integrations.import.browseFiles": "Browse files",
  "datox.integrations.import.connectedSources": "Connected sources",
  "datox.integrations.import.empty": "No connected integrations yet.",
  "datox.integrations.import.file": "Cloud file",
  "datox.integrations.import.folder": "Folder",
  "datox.integrations.import.importing": "Importing...",
  "datox.integrations.import.failed": "Could not import files. Try again.",
  "datox.integrations.import.unsupported": "File import is not available for this connected source.",
  "datox.fileIntegrations.external": "External integrations",
  "datox.integrations.import.noFiles": "No files found for this integration.",
  "datox.integrations.import.root": "Root",
  "datox.integrations.import.selected": "Import {{count}} selected",
  "datox.integrations.import.selectedCount": "{{count}} files selected",
  "datox.integrations.reconnect": "Reconnect",
  "datox.integrations.empty": "No integrations match your search.",
  "datox.integrations.description.accounting": "Connect accounting records, invoices, payments, and finance exports from {{name}}.",
  "datox.integrations.description.airtable": "Sync structured operational tables and workflow trackers.",
  "datox.integrations.description.ai": "Use {{name}} workspace data and model operations as Datox workflow context.",
  "datox.integrations.description.analytics": "Import analytics, dashboards, and operational insights from {{name}}.",
  "datox.integrations.description.asana": "Connect task management workflows and compliance projects.",
  "datox.integrations.description.aws": "Connect large-scale financial datasets, exports, and structured files from AWS.",
  "datox.integrations.description.azure-blob-storage": "Access enterprise data lakes, filings, and financial exports stored in Azure.",
  "datox.integrations.description.box": "Sync enterprise documents and regulatory files from Box.",
  "datox.integrations.description.communication": "Capture communications, messages, and collaboration records from {{name}}.",
  "datox.integrations.description.compliance": "Import compliance evidence, controls, and audit context from {{name}}.",
  "datox.integrations.description.confluence": "Import knowledge base articles, procedures, and audit documentation.",
  "datox.integrations.description.content": "Sync content, documents, and published records from {{name}}.",
  "datox.integrations.description.crmGeneric": "Access CRM records, contacts, accounts, and customer activity from {{name}}.",
  "datox.integrations.description.devtools": "Connect engineering activity, repositories, issues, and release history from {{name}}.",
  "datox.integrations.description.documents": "Import documents, contracts, signatures, and review evidence from {{name}}.",
  "datox.integrations.description.dropbox": "Import team files and compliance evidence from Dropbox.",
  "datox.integrations.description.ecommerce": "Connect commerce orders, customers, products, and operational records from {{name}}.",
  "datox.integrations.description.figma": "Import product designs, workflow diagrams, and UI documentation.",
  "datox.integrations.description.github": "Access repositories, documentation, and release history for technical audit trails.",
  "datox.integrations.description.gitlab": "Import DevOps activity, CI/CD logs, and engineering documentation.",
  "datox.integrations.description.google-cloud-storage": "Import cloud-hosted datasets, reports, and operational files.",
  "datox.integrations.description.google-drive": "Import Excel, PDF, fund reports, investor files, and compliance documents from Google Drive.",
  "datox.integrations.description.hr": "Import HR records, employee data, hiring workflows, and people operations context from {{name}}.",
  "datox.integrations.description.hubspot": "Import customer interactions, onboarding data, and communication history.",
  "datox.integrations.description.iam": "Connect identity, access, and security events from {{name}}.",
  "datox.integrations.description.intercom": "Access customer conversations, onboarding chats, and support interactions.",
  "datox.integrations.description.jira": "Connect tickets, audit tasks, and remediation workflows.",
  "datox.integrations.description.knowledge": "Import knowledge base content, learning records, and source documentation from {{name}}.",
  "datox.integrations.description.linear": "Import engineering issues, release planning, and product execution workflows.",
  "datox.integrations.description.marketing": "Sync campaigns, contacts, engagement data, and marketing operations from {{name}}.",
  "datox.integrations.description.microsoft-teams": "Sync chats, meeting files, and collaboration records.",
  "datox.integrations.description.notion": "Use internal notes, policies, and procedures as workflow context.",
  "datox.integrations.description.one-drive": "Sync Microsoft OneDrive documents into Datox reporting and review workflows.",
  "datox.integrations.description.payments": "Connect payment records, invoices, disputes, and transaction context from {{name}}.",
  "datox.integrations.description.productivity": "Connect tasks, calendars, projects, and team workflows from {{name}}.",
  "datox.integrations.description.salesforce": "Access CRM records, investor data, and client activities.",
  "datox.integrations.description.sales": "Import sales conversations, pipeline context, and customer activity from {{name}}.",
  "datox.integrations.description.sharepoint-online": "Connect SharePoint sites, folders, and team documents for workflow automation.",
  "datox.integrations.description.slack": "Capture operational discussions, approvals, and compliance-related conversations.",
  "datox.integrations.description.trello": "Access boards, checklists, and operational workflows.",
  "datox.integrations.description.ticketing": "Import tickets, support issues, service history, and remediation workflows from {{name}}.",
  "datox.integrations.description.webflow": "Sync website content, published pages, and CMS data.",
  "datox.integrations.description.wordpress": "Import website articles, disclosures, and published content.",
  "datox.integrations.description.zendesk": "Import support tickets, customer issues, and service history.",
  "datox.artifacts.title": "Reports",
  "datox.artifacts.empty": "Generated reports will appear here.",
  "datox.artifacts.status": "Status: {{status}}",
  "datox.artifacts.type": "Type: {{type}}",
  "datox.artifacts.download": "Download",
  "datox.artifacts.downloading": "Downloading...",
  "datox.sessions.title": "Sessions",
  "datox.sessions.new": "New chat",
  "datox.sessions.empty": "No chat sessions yet.",
  "datox.session.defaultTitle": "New custom report chat",
  "datox.chat.title": "Report chat",
  "datox.chat.subtitle": "Ask the agent to inspect files, extract data, transform results, or draft a report.",
  "datox.chat.empty": "Create a session and start chatting to build a report.",
  "datox.chat.user": "You",
  "datox.chat.assistant": "Datox Agent",
  "datox.chat.thinking": "Thinking...",
  "datox.chat.placeholder": "Ask the agent to generate a report from uploaded files...",
  "datox.chat.hint": "Uploaded files are sent as scoped project context.",
  "datox.chat.send": "Send",
  "datox.chat.streaming": "Working...",
  "datox.login.title": "Sign in to Datox",
  "datox.login.subtitle": "Use your Microsoft account to access your report automation projects and chat sessions.",
  "datox.login.badge": "Agentic report workflow automation",
  "datox.login.panel.title": "Access your workspace",
  "datox.login.panel.description": "Sign in with your company Microsoft account to continue to Datox Cowork.",
  "datox.login.button": "Sign in with Microsoft",
  "datox.login.loading": "Preparing sign in...",
  "datox.login.logout": "Sign out {{email}}",
  "datox.login.footer": "Secure access powered by Microsoft Entra ID",
  "datox.login.metric.files.value": "Files",
  "datox.login.metric.files.label": "Upload and inspect source documents",
  "datox.login.metric.workflow.value": "Workflow",
  "datox.login.metric.workflow.label": "Extract, transform, and validate data",
  "datox.login.metric.report.value": "Reports",
  "datox.login.metric.report.label": "Generate HTML, PDF, Word, and JSON outputs",
  "datox.login.secure.title": "Secure by design",
  "datox.login.secure.description": "Your sessions, files, generated reports, and approvals are scoped to your Datox company context.",
  "datox.login.msalMissing": "Microsoft sign-in is not configured. Set VITE_DATOX_MSAL_CLIENT_ID before connecting to the Datox API.",
}
